import {
    AbcOutlined,
    AddOutlined,
    ArrowBackOutlined,
    AttachFileOutlined,
    BadgeOutlined,
    CheckCircleOutlineOutlined,
    CheckCircleRounded,
    CloseOutlined,
    DateRangeOutlined,
    DeleteOutlineOutlined,
    DoNotDisturbOnRounded,
    DriveFileRenameOutlineOutlined,
    EmailOutlined,
    HelpOutlineOutlined,
    KeyOutlined,
    LocalAirportOutlined,
    PersonOutlineOutlined,
    PhoneOutlined,
    PinOutlined,
    PlaceOutlined,
    RemoveCircleOutlineOutlined,
    SaveOutlined,
    SearchOutlined,
    SettingsOutlined,
    TapAndPlayOutlined
} from "@mui/icons-material";

import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Alert,
    Autocomplete,
    Box,
    Button,
    Checkbox,
    Chip,
    Dialog,
    DialogActions,
    Fab,
    FormControl,
    FormControlLabel,
    FormGroup,
    Grid,
    IconButton,
    InputLabel,
    Paper,
    Skeleton,
    Stack,
    styled,
    Switch,
    SwitchProps,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Tooltip,
    Typography,
} from "@mui/material";

import { GridColDef } from "@mui/x-data-grid";

import {
    ChangeEvent,
    SyntheticEvent,
    useCallback,
    useEffect,
    useMemo,
    useRef,
    useState,
} from "react";

import {
    CityType,
    CNHCategoryType,
    CountryType,
    CustomerListType,
    DepartmentSimpleType,
    DriverDialogSection,
    DriverDirectdLookupType,
    DriverRequestType,
    DriverType,
    IdentifierField,
    PermissionsType,
    SecretarySimpleType,
    SelectedParametersType,
    StateType,
    UserType,
} from "../../../types/types";

import { ContentProps, Toast } from "primereact/toast";

import { SetterOrUpdater, useRecoilValue } from "recoil";
import { useCookies } from "react-cookie";

import {
    cpfFormatter,
    formatterZipCode,
    getFilteredList,
    phoneNumberFormatter,
    registerFormatter,
    setToastRefToOpen,
} from "../../../functions/functions";

import GridTemplate from "../../../components/GridTemplate";
import dayjs from "dayjs";
import { useLocation } from "react-router-dom";
import Rmodal from "../../../components/Rmodal";

import {
    ArrowDropDownIcon,
    DatePicker,
    LocalizationProvider,
} from "@mui/x-date-pickers";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

import "dayjs/locale/pt-br";

import findAllDriversByCustomerIdCrudResponse from "../../../resources/Api/driver/FindAllDriversByCustomerIdCrudResponse";
import findAllCountriesListResponse from "../../../resources/Api/country/findAllCountriesListResponse";
import findAllStatesByCountryIdListResponse from "../../../resources/Api/state/findAllStatesByCountryIdListResponse";
import findAllCitiesByStateIdListResponse from "../../../resources/Api/city/findAllCitiesByStateIdListResponse";
import findAllCnhCategoriesListResponse from "../../../resources/Api/cnhcategory/findAllCnhCategoriesListResponse";
import saveDriverByCustomer from "../../../resources/Api/driver/saveDriverByCustomer";
import updateDriverByCustomer from "../../../resources/Api/driver/updateDriverByCustomer";
import updateDriverStatusById from "../../../resources/Api/driver/updateDriverStatusById";
import findAllDriversExportResponse from "../../../resources/Api/driver/findAllDriversExportResponse";
import { userAtom } from "../../../atoms/atoms";

import "./styles.css";
import findDriverDirectdByCpf from "../../../resources/Api/driver/findDriverDirectdByCpf";
import DirectdIndicators from "../../../components/DirectdIndicators";
import useDirectdLookup from "../../../hooks/useDirectdLookup";
import useCepAutofill from "../../../hooks/useCepAutofill";

import { customerDefault, departmentDefault, MENUS_ITENS, secretaryDefault } from "../../../consts/consts";
import userFindAllSecretariesListResponse from "../../../resources/Api/user/userFindAllSecretariesListResponse";
import userFindAllDepartmentsListResponse from "../../../resources/Api/user/userFindAllDepartmentsListResponse";
import customerFindAllListResponse from "../../../resources/Api/customer/customerFindAllListResponse";
import findAllSecretariesByCustomerIdListResponse from "../../../resources/Api/secretary/findAllSecretariesByCustomerIdListResponse";
import findAllDepartmentsByCustomerIdAndSecretaryIdListResponse from "../../../resources/Api/department/findAllDepartmentsByCustomerIdAndSecretaryIdListResponse";
import DriverParameter from "./driverParameter";
import { isImpersonationLocked } from "../../../utils/impersonation";

/** Valida os digitos verificadores do CPF (so digitos). */
const isValidCpf = (cpf: string): boolean => {
    if (!/^\d{11}$/.test(cpf) || /^(\d)\1{10}$/.test(cpf)) return false;
    const digit = (length: number) => {
        const sum = cpf
            .slice(0, length)
            .split("")
            .reduce((total, char, index) => total + Number(char) * (length + 1 - index), 0);
        const rest = (sum * 10) % 11;
        return rest === 10 ? 0 : rest;
    };
    return digit(9) === Number(cpf[9]) && digit(10) === Number(cpf[10]);
};

export function useDebouncedSearch(query: string, delay = 800) {
    const [debouncedQuery, setDebouncedQuery] = useState(query);
    const [lastSearchedQuery, setLastSearchedQuery] = useState("");

    useEffect(() => {
        const timer = setTimeout(() => {
            if (query !== lastSearchedQuery) {
                setDebouncedQuery(query);
            }
        }, delay);

        return () => clearTimeout(timer);
    }, [query, delay, lastSearchedQuery]);

    const markSearched = useCallback((q: string) => {
        setLastSearchedQuery(q);
    }, []);

    return { debouncedQuery, lastSearchedQuery, markSearched };
}

const columns: GridColDef[] = [
    {
        field: "activated",
        type: "boolean",
        width: 120,
        editable: false,
        sortable: false,
        renderHeader: () => (
            <Chip
                sx={{
                    color: "#fff",
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={"Ativo"}
                icon={
                    <KeyOutlined style={{ height: 30, width: 30, fill: "#ffff" }} />
                }
            />
        ),
        renderCell: (item) => (
            <Chip
                sx={{ background: "transparent" }}
                icon={
                    item.row.activated ? (
                        <CheckCircleRounded
                            className="activated"
                            style={{ height: 28, width: 28 }}
                        />
                    ) : (
                        <DoNotDisturbOnRounded
                            className="deactivated"
                            style={{ height: 28, width: 28 }}
                        />
                    )
                }
            />
        ),
    },
    {
        field: "name",
        align: "left",
        width: 280,
        editable: false,
        sortable: true,
        renderHeader: () => (
            <Chip
                sx={{
                    color: "#fff",
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={"Nome"}
                icon={<AbcOutlined style={{ height: 30, width: 30, fill: "#ffff" }} />}
            />
        ),
        renderCell: (item) => (
            <Chip
                sx={{
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={item.row.name}
            />
        ),
    },
    {
        field: "cnh",
        width: 140,
        align: "left",
        editable: false,
        sortable: true,
        renderHeader: () => (
            <Chip
                sx={{
                    color: "#fff",
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={"CNH"}
                icon={
                    <BadgeOutlined style={{ height: 30, width: 30, fill: "#ffff" }} />
                }
            />
        ),
        renderCell: (item) => (
            <Chip
                sx={{
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={item.row?.cnh ?? "-"}
            />
        ),
    },
    {
        field: "cnhExpireDate",
        align: "left",
        width: 200,
        editable: false,
        sortable: true,
        renderHeader: () => (
            <Chip
                sx={{
                    color: "#fff",
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={"Data validade"}
                icon={
                    <DateRangeOutlined style={{ height: 30, width: 30, fill: "#ffff" }} />
                }
            />
        ),
        renderCell: (item) => {
            const isCnhExpired = Boolean(item.row.cnhExpireDate) && dayjs(item.row.cnhExpireDate).isBefore(dayjs());

            return (
                <Tooltip
                    title={isCnhExpired ? "Alerta - CNH vencida." : ""}
                    arrow
                    describeChild
                    componentsProps={{
                        tooltip: {
                            sx: {
                                backgroundColor: "warning.main",
                                color: "warning.contrastText",
                            },
                        },
                        arrow: { sx: { color: "warning.main" } },
                    }}
                >
                    <Chip
                        className={isCnhExpired ? "deactivated" : "activated"}
                        style={{
                            background: "transparent",
                            fontFamily: "Prometo",
                        }}
                        label={item.row?.cnhExpireDate ? dayjs(item.row?.cnhExpireDate).format("DD/MM/YYYY") : "-"}
                    />
                </Tooltip>
            );
        },
    },
    {
        field: "identifier",
        align: "left",
        width: 280,
        headerClassName: "last-column",
        editable: false,
        sortable: true,
        renderHeader: () => (
            <Chip
                sx={{
                    color: "#fff",
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={"Identficadores/Ibuttons"}
                icon={
                    <DateRangeOutlined style={{ height: 30, width: 30, fill: "#ffff" }} />
                }
            />
        ),
        renderCell: (item) => (
            <Chip
                className={item.row?.driverIdentifiers.length <= 0 ? "deactivated" : "activated"}
                style={{
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={item.row?.driverIdentifiers.length > 0 ?
                    `${item.row?.driverIdentifiers.map((name: string) => name).toString().replaceAll(",", ", ")}` :
                    "-"}
            />
        ),
    },
    {
        field: "parameterIcon",
        sortable: false,
        headerName: "",
        width: 160,
        renderCell: (item: any) => {
            const getItemPermission = (id: number) => {
                return item.row.permissions?.find((permission: PermissionsType) => {
                    if (permission.optionItem.id === id) {
                        const { optionItem, ...rest } = permission;
                        return rest;
                    }
                });
            };

            const permissions = getItemPermission(Number(MENUS_ITENS.DRIVERS));
            const canView = permissions ? permissions.canView : true;

            return (
                <Chip
                    disabled={!canView}
                    sx={{
                        marginRight: 2,
                        fontFamily: "Prometo",
                        background: canView ? "#00B700" : "#BDBDBD",
                        color: "#ffff",
                        padding: 1,
                    }}
                    onClick={(e) => {
                        e.stopPropagation();

                        if (!canView) return;

                        if (item.row.openDetails) {
                            item.row.openDetails(true);
                        }

                        if (item.row.callback) {
                            item.row.callback?.(item.row);
                        }
                    }}
                    label="Parâmetros"
                    icon={<SettingsOutlined style={{ height: 25, width: 25, fill: "#ffff" }} />}
                />
            );
        },
    }
];

const rowsOptions = (
    list: Array<DriverType>,
    openDetails?: SetterOrUpdater<boolean>,
    callback?: (...args: any) => void,
    permissions?: Array<PermissionsType>,
): Array<DriverType> => {
    const result = [...list];
    return result.map((item) => ({ ...item, openDetails, callback, permissions }));
};

/**
 * DriverPage - Screen that renders a page to create and manage drivers
 * @component-screen
 */
const DriverPage = ({ isHiddenMenu }: { isHiddenMenu: boolean }) => {
    //atoms
    const getCurrentUser = useRecoilValue<UserType>(userAtom);

    // functionalities states
    const [isOnline, setIsOnline] = useState(true);
    const [loading, setLoading] = useState(false);
    const [validationText, setTextValidation] = useState<string>("");
    const [isFieldsValid, setFieldsIsValid] = useState<boolean>(true);
    const [statusMessage, setStatusMessage] = useState<"warn" | "success" | "info" | "error" | undefined>("warn");
    const [isToastVisible, setIsToastVisible] = useState(false);
    const [inEdit, setInEdit] = useState<boolean>(false);
    const [inInsert, setInInsert] = useState<boolean>(false);
    const [isOpenDetails, setIsOpenDetails] = useState<boolean>(false);
    const [infoExpanded, setInfoExpanded] = useState<boolean>(true);
    const [info2Expanded, setInfo2Expanded] = useState<boolean>(false);
    const [query, setQuery] = useState<string>("");
    const [filteredList, setFilteredList] = useState<Array<DriverType>>([]);

    const [isLastPage, setIsLastPage] = useState<boolean>(true);
    const [numberOfElementsPerPage, setNumberOfElementsPerPage] = useState<number>(0);
    const [numberOfElements, setNumberOfElements] = useState<number>(0);
    const [pageNumber, setPageNumber] = useState<number>(0);

    // states
    const [driversList, setDriversList] = useState<Array<DriverType>>([]);
    const [selectedDriver, setSelectedDriver] = useState<DriverType>({
        id: -1,
    } as any);

    const [cnhCategoryList, setCnhCategoryList] = useState<
        Array<CNHCategoryType>
    >([]);
    const [countriesList, setCountriesList] = useState<Array<CountryType>>([]);
    const [statesList, setStatesList] = useState<Array<StateType>>([]);
    const [citiesList, setCitiesList] = useState<Array<CityType>>([]);

    const [driverName, setDriverName] = useState<string>("");
    const [driverCpf, setDriverCpf] = useState<string | null>("");
    const [useRegisterNumber, setUseRegisterNumber] = useState<boolean>(false);
    const [driverRegistration, setDriverRegistration] = useState<string | null>("");
    const [driverCnh, setDriverCnh] = useState<string>("");
    const [driverCnhExpireDate, setDriverCnhExpireDate] = useState<string>(
        dayjs().add(1, "day").toISOString()
    );

    const [driverCnhCategory, setDriverCnhCategory] = useState<string>("");
    const [driverBirthDate, setDriverBirthDate] = useState<string>(
        dayjs().subtract(18, "years").toISOString()
    );

    const [driverCountry, setDriverCountry] = useState<string>("");
    const [driverState, setDriverState] = useState<string>("");
    const [driverCity, setDriverCity] = useState<string>("");
    const [cep, setCep] = useState<string>("");
    const [driverAddress, setDriverAddress] = useState<string>("");
    const [driverAddressNumber, setDriverAddressNumber] = useState<string>("");
    const [driverAddressComplement, setDriverAddressComplement] = useState<string>("");
    const [driverPhone, setDriverPhone] = useState<string>("");
    const [driverHasWhatsApp, setDriverHasWhatsApp] = useState<boolean>(false);
    const [driverEmail, setDriverEmail] = useState<string>("");

    const [driverIdentifiers, setDriverIndentifiers] = useState<Array<string>>([]);
    const [identifierFields, setIdentifierFields] = useState<IdentifierField[]>([
        { key: "identifier", value: "", label: "Identificador" }
    ]);

    const [report, setReport] = useState<ArrayBuffer>(new ArrayBuffer(0));
    const [exportType, setExportType] = useState<string>("");

    const [secretariesList, setSecretariesList] = useState<Array<SecretarySimpleType>>([]);
    const [departmentsList, setDepartmentsList] = useState<Array<DepartmentSimpleType>>([]);
    const [customersList, setCustomersList] = useState<Array<CustomerListType>>([]);

    const [customer, setCustomer] = useState<CustomerListType>(customerDefault);
    const [secretary, setSecretary] = useState<SecretarySimpleType>(secretaryDefault);
    const [department, setDepartment] = useState<DepartmentSimpleType>(departmentDefault);

    const [canSeach, setCanSearch] = useState<boolean>(false);
    const [typingTimer, setTypingTimer] = useState<any>(0);
    const [isViewingAll, setIsViewingAll] = useState(false);

    // identifier history dialog states
    const [isOpenIdentifierHistory, setIsOpenIdentifierHistory] = useState<boolean>(false);
    const [identifierHistorySearch, setIdentifierHistorySearch] = useState<string>("");

    // driver parameters/attachments dialog states
    const [isOpenDriverParameter, setIsOpenDriverParameter] = useState<boolean>(false);
    const [driverParameterSection, setDriverParameterSection] =
        useState<DriverDialogSection>("parameters");
    const [driverParameterHasUnsavedChanges, setDriverParameterHasUnsavedChanges] =
        useState<boolean>(false);

    // refs
    const toastModalRef = useRef<Toast>(null);
    const toastRef = useRef<Toast>(null);
    const toastDriverParameterRef = useRef<Toast>(null);

    // cookies
    const [cookies, _] = useCookies(["selectedParameters", "token"]);

    // hooks e const
    const location = useLocation();
    // const { debouncedQuery, markSearched } = useMemo(() => useDebouncedSearch(query, 1200), [query]);

    const isCnhExpiredDate = useMemo(() => {
        return dayjs(selectedDriver.cnhExpireDate).isBefore(dayjs());
    }, [selectedDriver.cnhExpireDate]);

    const currentParameters: SelectedParametersType = useMemo(() => cookies.selectedParameters, [cookies.selectedParameters]);

    const handleClose = useCallback(() => {
        setLoading(false);
        setStatusMessage("warn");
        setIsToastVisible(false);
        setTextValidation("");
        setIsOpenDetails(false);
        setSelectedDriver({ id: -1 } as any);
        setInEdit(false);
        setInInsert(false);
        setDriverName("");
        setDriverIndentifiers([]);
        setIdentifierFields([{ key: "identifier", value: "", label: "Identificador" }]);
        setDriverCpf("");
        setDriverAddress("");
        setDriverCnh("");
        setDriverCnhExpireDate(dayjs().add(1, "day").toISOString());
        setDriverCnhCategory("");
        setDriverBirthDate(dayjs().subtract(18, "years").toISOString());
        setDriverCountry("");
        setDriverState("");
        setDriverCity("");
        setCep("");
        setDriverAddressNumber("");
        setDriverAddressComplement("");
        setDriverPhone("");
        setDriverHasWhatsApp(false);
        setDriverEmail("");
        setInfo2Expanded(false);
        setInfoExpanded(true);
        setDriverRegistration("");
        setUseRegisterNumber(false);
        setIdentifierHistorySearch("");
    }, []);

    useEffect(() => {
        const ref = isOpenDriverParameter
            ? toastDriverParameterRef
            : isOpenDetails
                ? toastModalRef
                : toastRef;
        if (validationText && !isFieldsValid && !isToastVisible) {
            setToastRefToOpen(
                ref,
                validationText,
                "Atenção!",
                statusMessage,
                undefined,
                3000,
                false
            );
        }
    }, [
        isOpenDetails,
        isOpenDriverParameter,
        validationText,
        isFieldsValid,
        statusMessage,
        isToastVisible,
    ]);

    const getAllDrivers = useCallback(
        async (search: string = "", status: string = "activated", page: number = 0, size: number = 100) => {
            const token: string = cookies.token || sessionStorage.getItem("token");
            const currentParameters: SelectedParametersType = cookies.selectedParameters;

            const customerId = location?.state?.customerId ?? (!getCurrentUser.configs.isManager ? currentParameters.customer.id : customer.id);
            const departmentId = location?.state?.departmentId ?? (!getCurrentUser.configs.isManager && !currentParameters.isViewingAll ? currentParameters.department.id : department.id);
            const isViewAll = getCurrentUser.configs.isManager && !location?.state?.departmentId ? isViewingAll : (!getCurrentUser.configs.isManager && currentParameters.isViewingAll);

            setLoading(true);
            try {
                const { data } = await findAllDriversByCustomerIdCrudResponse(
                    token,
                    customerId,
                    departmentId,
                    status,
                    page,
                    size,
                    isViewAll,
                    search
                );

                // setFilteredList(data.content);
                setDriversList(data.content);
                setIsLastPage(data.last);
                setNumberOfElementsPerPage(data.numberOfElements);
                setPageNumber(data.pageable.pageNumber);
                if (data.first) {
                    setNumberOfElements(data.totalElements);

                }

            } catch (error: any) {
                console.log(error);
                setDriversList([]);
            } finally {
                setTimeout(() => {
                    setLoading(false);
                }, 2000);
            }
        },
        [isViewingAll, cookies.selectedParameters, cookies.token, location?.state?.departmentId, location?.state?.customerId, customer.id, department.id, getCurrentUser.configs.isManager]
    );

    useEffect(() => {
        getAllDrivers();
    }, [getAllDrivers]);

    /**
     * Consulta da CNH na Direct Data (paga; o backend guarda cache de 30 dias), no onBlur do CPF e depois de uma
     * pausa na digitacao. Na inclusao sobrescreve os campos; na edicao so preenche os vazios e nao consulta o CPF salvo.
     */
    const cpfDigits = (driverCpf ?? "").replace(/\D/g, "");
    // CPF em que o usuario saiu do campo: a mensagem de invalido so aparece com o CPF completo ou depois do blur.
    const [cpfBlurredValue, setCpfBlurredValue] = useState<string>("");
    const isCpfInvalid =
        (inInsert || inEdit) &&
        !useRegisterNumber &&
        cpfDigits.length > 0 &&
        !isValidCpf(cpfDigits) &&
        (cpfDigits.length === 11 || cpfBlurredValue === cpfDigits) &&
        !(inEdit && cpfDigits === (selectedDriver?.cpf ?? "").replace(/\D/g, ""));

    const {
        loading: directdLoading,
        result: directdResult,
        error: directdError,
        lookupNow: lookupCpfNow,
    } = useDirectdLookup<DriverDirectdLookupType>({
        rawValue: driverCpf ?? "",
        normalize: (raw) => raw.replace(/\D/g, ""),
        isValid: isValidCpf,
        enabled: (inInsert || inEdit) && !useRegisterNumber,
        shouldSkip: (cpf) => inEdit && cpf === (selectedDriver?.cpf ?? "").replace(/\D/g, ""),
        fetcher: async (cpf) => {
            const token: string = cookies.token || sessionStorage.getItem("token");
            const { data } = await findDriverDirectdByCpf(token, cpf);
            return data as DriverDirectdLookupType;
        },
        onResult: (result) => {
            const fill = (setter: (updater: (previous: string) => string) => void, value: string | null | undefined) => {
                if (!value) return;
                setter((previous) => (inInsert || !previous ? value : previous));
            };

            fill(setDriverName, result.name);
            fill(setDriverCnh, result.cnh);
            fill(setDriverCnhCategory, cnhCategoryList.find((item) => item.id === result.cnhCategoryId)?.name);
            // Datas tem valor padrao no formulario, entao so sao preenchidas na inclusao.
            // Sem data na consulta, limpa o padrao (hoje - 18 anos) para nao parecer que veio da Direct Data;
            // o campo e obrigatorio, entao o usuario precisa informar.
            if (inInsert) {
                setDriverBirthDate(result.birthDate ? dayjs(result.birthDate).startOf("day").toDate().toISOString() : "");
            }
            if (inInsert && result.cnhExpireDate) {
                setDriverCnhExpireDate(dayjs(result.cnhExpireDate).toISOString());
            }
        },
    });

    /** Endereco pelo CEP (ViaCEP, gratuito): preenche endereco, pais, estado e cidade. */
    const cepAutofill = useCepAutofill({
        cep,
        enabled: inInsert || inEdit,
        savedCep: selectedDriver?.cep,
        inEdit,
        onAddress: (address) => {
            if (address.street) setDriverAddress([address.street, address.neighborhood].filter(Boolean).join(" - ").slice(0, 100));
        },
        location: {
            countriesList,
            statesList,
            citiesList,
            country: driverCountry,
            state: driverState,
            setCountry: setDriverCountry,
            setState: setDriverState,
            setCity: setDriverCity,
        },
    });
    const { pendingStateName, pendingCityName } = cepAutofill;

    const onSave = useCallback(async () => {
        const token: string = cookies.token || sessionStorage.getItem("token");
        const customerId = location?.state?.customerId ?? (!getCurrentUser.configs.isManager ? currentParameters.customer.id : customer.id);
        const departmentId = location?.state?.departmentId ?? (!getCurrentUser.configs.isManager && !currentParameters?.isViewingAll ? currentParameters.department.id : department.id);

        setLoading(true);

        const cnhCategoryId = cnhCategoryList.find(
            (item) => item.name === driverCnhCategory
        )?.id ?? null;

        const countryId = countriesList.find(
            (item) => item.name === driverCountry
        )?.id;

        const stateId = statesList.find((item) => item.name === driverState)?.id;
        const cityId = citiesList.find((item) => item.name === driverCity)?.id;

        const data: DriverRequestType = {
            id: -1,
            name: driverName,
            driverIdentifiers: driverIdentifiers,
            cpf: driverCpf,
            cnh: driverCnh,
            registrationNumber: driverRegistration,
            useRegisterNumber: useRegisterNumber,
            cnhCategoryId: cnhCategoryId,
            cnhExpireDate: driverCnhExpireDate,
            birthDate: driverBirthDate,
            customerId: customerId,
            departmentId: departmentId,
            countryId: countryId!!,
            stateId: stateId!!,
            cityId: cityId!!,
            cep: cep ?? "",
            address: driverAddress ?? "",
            addressNumber: driverAddressNumber ?? "",
            complement: driverAddressComplement ?? "",
            phone: driverPhone,
            isWhatsApp: driverHasWhatsApp,
            email: driverEmail ?? "",
        };

        if (
            !data.name ||
            data.departmentId === -1 ||
            // data.driverIdentifiers.length === 0 ||
            (!data.cpf && !data.useRegisterNumber) ||
            (!data.registrationNumber && data.useRegisterNumber) ||
            !data.birthDate ||
            !data.countryId ||
            !data.stateId ||
            !data.cityId ||
            !data.phone
        ) {
            setTextValidation(
                "Todos os campos marcados com * são obrigatórios, preencha e tente novamente."
            );
            setStatusMessage("warn");
            setFieldsIsValid(false);
            setLoading(false);
            return;
        }

        try {
            await saveDriverByCustomer(token, data);
            setTextValidation("Registro salvo com sucesso.");
            setStatusMessage("success");
            setFieldsIsValid(false);

            setTimeout(() => {
                handleClose();
                getAllDrivers();
            }, 3000);
        } catch (error: any) {
            setLoading(false);
            const { data } = error.response;

            const errors = data.reason.split(".");
            errors.forEach((message: any, index: number) => {
                if (index === 0) {
                    setFieldsIsValid(false);
                    setStatusMessage("warn");
                    setTextValidation(message);
                }
            });
        }
    }, [
        citiesList,
        countriesList,
        statesList,
        cnhCategoryList,
        driverRegistration,
        useRegisterNumber,
        currentParameters?.isViewingAll,
        getCurrentUser.configs.isManager,
        department.id,
        customer.id,
        currentParameters.customer.id,
        currentParameters.department.id,
        location?.state?.departmentId,
        location?.state?.customerId,
        cookies.token,
        driverName,
        driverIdentifiers,
        driverCpf,
        driverCnh,
        driverCnhExpireDate,
        driverCnhCategory,
        driverBirthDate,
        driverCountry,
        driverState,
        driverCity,
        cep,
        driverAddress,
        driverAddressNumber,
        driverAddressComplement,
        driverPhone,
        driverHasWhatsApp,
        driverEmail,
        handleClose,
        getAllDrivers,
    ]);

    const onUpdate = useCallback(async () => {
        const token: string = cookies.token || sessionStorage.getItem("token");
        const currentParameters: SelectedParametersType = cookies.selectedParameters;
        const customerId = location?.state?.customerId ?? (!getCurrentUser.configs.isManager ? currentParameters.customer.id : customer.id);
        // const departmentId = location?.state?.departmentId || currentParameters.department.id

        setLoading(true);

        const cnhCategoryId = cnhCategoryList.find((item) => item.name === driverCnhCategory)?.id ?? null;
        const countryId = countriesList.find((item) => item.name === driverCountry)?.id;
        const stateId = statesList.find((item) => item.name === driverState)?.id;
        const cityId = citiesList.find((item) => item.name === driverCity)?.id;

        const data: DriverRequestType = {
            id: selectedDriver.id,
            name: driverName,
            driverIdentifiers: driverIdentifiers,
            cpf: driverCpf,
            cnh: driverCnh,
            registrationNumber: driverRegistration,
            useRegisterNumber: useRegisterNumber,
            cnhCategoryId: cnhCategoryId,
            cnhExpireDate: driverCnhExpireDate,
            birthDate: driverBirthDate,
            customerId: customerId,
            departmentId: selectedDriver.departmentId,
            countryId: countryId!!,
            stateId: stateId!!,
            cityId: cityId!!,
            cep: cep ?? "",
            address: driverAddress ?? "",
            addressNumber: driverAddressNumber ?? "",
            complement: driverAddressComplement ?? "",
            phone: driverPhone,
            isWhatsApp: driverHasWhatsApp,
            email: driverEmail ?? "",
        };

        if (
            !data.name ||
            // data.driverIdentifiers.length === 0 ||
            (!data.cpf && !data.useRegisterNumber) ||
            (!data.registrationNumber && data.useRegisterNumber) ||
            !data.birthDate ||
            !data.countryId ||
            !data.stateId ||
            !data.cityId ||
            !data.phone
        ) {
            setTextValidation(
                "Todos os campos marcados com * são obrigatórios, preencha e tente novamente."
            );
            setStatusMessage("warn");
            setFieldsIsValid(false);
            setLoading(false);
            return;
        }

        const hasEqualLength = data.driverIdentifiers.length === selectedDriver.driverIdentifiers.length;
        const idsElements = driverIdentifiers.filter((a) => !selectedDriver.driverIdentifiers.includes(a));
        const hasChangesOnIds = !hasEqualLength || idsElements.length > 0;

        // verifica se os campos não existem nos dois dados ou se são iguais
        if (
            ((!data.name && !selectedDriver.name) || data.name === selectedDriver.name) &&
            !hasChangesOnIds &&
            ((!data.cpf && !selectedDriver.cpf) || data.cpf === selectedDriver.cpf) &&
            ((!data.cnh && !selectedDriver.cnh) || data.cnh === selectedDriver.cnh) &&
            ((!data.cnhExpireDate && !selectedDriver.cnhExpireDate) || dayjs(data.cnhExpireDate).isSame(selectedDriver.cnhExpireDate, "date")) &&
            ((!data.cnhCategoryId && !selectedDriver.cnhCategoryId) || data.cnhCategoryId === selectedDriver.cnhCategoryId) &&
            ((!data.birthDate && !selectedDriver.birthDate) || dayjs(data.birthDate).isSame(selectedDriver.birthDate, "date")) &&
            ((!data.countryId && !selectedDriver.countryId) || data.countryId === selectedDriver.countryId) &&
            ((!data.stateId && !selectedDriver.stateId) || data.stateId === selectedDriver.stateId) &&
            ((!data.cityId && !selectedDriver.cityId) || data.cityId === selectedDriver.cityId) &&
            ((!data.cep && !selectedDriver.cep) || data.cep === selectedDriver.cep) &&
            ((!data.address && !selectedDriver.address) || data.address === selectedDriver.address) &&
            ((!data.addressNumber && !selectedDriver.addressNumber) || data.addressNumber === selectedDriver.addressNumber) &&
            ((!data.complement && !selectedDriver.complement) || data.complement === selectedDriver.complement) &&
            ((!data.phone && !selectedDriver.phone) || data.phone === selectedDriver.phone) &&
            ((!data.isWhatsApp && !selectedDriver.isWhatsApp) || data.isWhatsApp === selectedDriver.isWhatsApp) &&
            ((!data.email && !selectedDriver.email) || data.email === selectedDriver.email)
        ) {
            setTextValidation("Nada foi alterado.");
            setStatusMessage("warn");
            setFieldsIsValid(false);
            setLoading(false);
            return;
        }

        try {
            await updateDriverByCustomer(token, data.id, data);
            setTextValidation("Registro atualizado com sucesso.");
            setStatusMessage("success");
            setFieldsIsValid(false);

            setTimeout(() => {
                handleClose();
                getAllDrivers();
            }, 3000);
        } catch (error: any) {
            setLoading(false);
            const { data } = error.response;

            const errors = data.reason.split(".");
            errors.forEach((message: any, index: number) => {
                if (index === 0) {
                    setFieldsIsValid(false);
                    setStatusMessage("warn");
                    setTextValidation(message);
                }
            });
        }
    }, [
        driverRegistration,
        useRegisterNumber,
        selectedDriver,
        citiesList,
        countriesList,
        statesList,
        cnhCategoryList,
        customer.id,
        cookies.selectedParameters,
        getCurrentUser.configs.isManager,
        location?.state?.customerId,
        cookies.token,
        driverName,
        driverIdentifiers,
        driverCpf,
        driverCnh,
        driverCnhExpireDate,
        driverCnhCategory,
        driverBirthDate,
        driverCountry,
        driverState,
        driverCity,
        cep,
        driverAddress,
        driverAddressNumber,
        driverAddressComplement,
        driverPhone,
        driverHasWhatsApp,
        driverEmail,
        handleClose,
        getAllDrivers,
    ]);

    const getSecretariesList = useCallback(async () => {
        const token = cookies.token || sessionStorage.getItem("token");
        const userId = getCurrentUser.id;
        try {
            const response = await userFindAllSecretariesListResponse(
                token,
                userId
            );
            setSecretariesList(response.data);
        } catch (error) {
            console.log(error);
            setSecretariesList([]);
        }
    }, [cookies.token, getCurrentUser.id]);

    useEffect(() => {
        if (currentParameters?.isViewingAll && !getCurrentUser.configs.isManager) {
            getSecretariesList();
        }
    }, [getSecretariesList, currentParameters?.isViewingAll, getCurrentUser.configs.isManager]);

    const getDepartmentsList = useCallback(async () => {
        const token = cookies.token || sessionStorage.getItem("token");
        const userId = getCurrentUser.id;

        try {
            const response =
                await userFindAllDepartmentsListResponse(
                    token,
                    userId,
                    secretary?.id
                );
            setDepartmentsList(response.data);
        } catch (error) {
            console.log(error);
            setDepartmentsList([]);
        }
    }, [cookies.token, getCurrentUser.id, secretary.id]);

    useEffect(() => {
        if (currentParameters?.isViewingAll && !getCurrentUser.configs.isManager && secretary?.name) {
            getDepartmentsList();
        }
    }, [getDepartmentsList, secretary?.name, getCurrentUser.configs.isManager, currentParameters?.isViewingAll]);

    const getCountriesList = useCallback(async () => {
        const token: string = cookies.token || sessionStorage.getItem("token");
        setLoading(true);
        try {
            const { data } = await findAllCountriesListResponse(token);
            setCountriesList(data);
        } catch (error: any) {
            console.log(error);
            setCountriesList([]);
        } finally {
            setTimeout(() => {
                setLoading(false);
            }, 2000);
        }
    }, [cookies.token]);

    useEffect(() => {
        getCountriesList();
    }, [getCountriesList]);

    const getCnhCategoryList = useCallback(async () => {
        const token: string = cookies.token || sessionStorage.getItem("token");
        setLoading(true);
        try {
            const { data } = await findAllCnhCategoriesListResponse(token);
            setCnhCategoryList(data);
        } catch (error: any) {
            console.log(error);
            setCnhCategoryList([]);
        } finally {
            setTimeout(() => {
                setLoading(false);
            }, 2000);
        }
    }, [cookies.token]);

    useEffect(() => {
        getCnhCategoryList();
    }, [getCnhCategoryList]);

    const getStatesList = useCallback(async () => {
        const token: string = cookies.token || sessionStorage.getItem("token");
        const countryId = countriesList.find((item) => { if (item.name === driverCountry) return item })?.id;
        try {
            const { data } = await findAllStatesByCountryIdListResponse(
                token,
                countryId!!
            );
            setStatesList(data);
            setDriverState(
                pendingStateName(data)
                ?? data.find((item: any) => item.id === selectedDriver.stateId)?.name
                ?? ""
            );
        } catch (error: any) {
            console.log(error);
            setStatesList([]);
        }
    }, [cookies.token, driverCountry, countriesList, selectedDriver.stateId, pendingStateName]);

    useEffect(() => {
        if (driverCountry) {
            getStatesList();
        }
    }, [getStatesList, driverCountry]);

    const getCityList = useCallback(async () => {
        const token: string = cookies.token || sessionStorage.getItem("token");
        const stateId = statesList.find((item) => { if (item.name === driverState) return item })?.id;
        try {
            const { data } = await findAllCitiesByStateIdListResponse(
                token,
                stateId!!
            );
            setCitiesList(data);
            setDriverCity(
                pendingCityName(data)
                ?? data.find((item: any) => item.id === selectedDriver.cityId)?.name
                ?? ""
            );
        } catch (error: any) {
            console.log(error);
            setCitiesList([]);
        }
    }, [cookies.token, statesList, driverState, selectedDriver.cityId, pendingCityName]);

    useEffect(() => {
        if (driverCountry && driverState) {
            getCityList();
        }
    }, [getCityList, driverCountry, driverState]);

    const verifyBeforeCancel = useCallback(
        (selected: DriverType) => {
            const ref = toastModalRef;
            let canCancel = true;

            if (inEdit && !inInsert) {
                const cnhCategoryId = cnhCategoryList.find(
                    (item) => item.name === driverCnhCategory
                )?.id;

                const countryId = countriesList.find(
                    (item) => item.name === driverCountry
                )?.id;

                const stateId = statesList.find(
                    (item) => item.name === driverState
                )?.id;

                const cityId = citiesList.find((item) => item.name === driverCity)?.id;

                const hasEqualLength = driverIdentifiers.length === selected.driverIdentifiers.length;
                const idsElements = driverIdentifiers.filter((a) => !selected.driverIdentifiers.includes(a));
                const hasChangesOnIds = !hasEqualLength || idsElements.length > 0;

                if (
                    driverName !== selected.name ||
                    hasChangesOnIds ||
                    driverCpf !== selected.cpf ||
                    driverCnh !== selected.cnh ||
                    dayjs(driverCnhExpireDate).date() !==
                    dayjs(selected.cnhExpireDate).date() ||
                    cnhCategoryId !== selected.cnhCategoryId ||
                    dayjs(driverBirthDate).startOf("day").date() !== dayjs(selected.birthDate).startOf("day").date() ||
                    countryId !== selected.countryId ||
                    stateId !== selected.stateId ||
                    cityId !== selected.cityId ||
                    (cep && cep !== selected.cep) ||
                    (driverAddress && driverAddress !== selected.address) ||
                    (driverAddressNumber && driverAddressNumber !== selected.addressNumber) ||
                    (driverAddressComplement &&
                        driverAddressComplement !== selected.complement) ||
                    driverPhone !== selected.phone ||
                    driverHasWhatsApp !== (selected?.whatsApp || selected?.isWhatsApp) ||
                    (driverEmail && driverEmail !== selected.email)
                ) {
                    canCancel = false;
                }
            } else if (
                !inEdit &&
                inInsert &&
                (driverName ||
                    driverIdentifiers.length > 0 ||
                    driverCpf ||
                    driverCnh ||
                    dayjs(driverCnhExpireDate).date() !== dayjs().add(1, "day").date() ||
                    driverCnhCategory ||
                    dayjs(driverBirthDate).date() !==
                    dayjs().subtract(18, "years").date() ||
                    driverCountry ||
                    driverState ||
                    driverCity ||
                    cep ||
                    driverAddress ||
                    driverAddressNumber ||
                    driverAddressComplement ||
                    driverPhone ||
                    driverEmail)
            ) {
                canCancel = false;
            }

            if (!canCancel) {
                if (!isToastVisible) {
                    setToastRefToOpen(
                        ref,
                        "Existem dados não salvos, deseja realmente cancelar?",
                        "Atenção!",
                        statusMessage,
                        {
                            content: (props: ContentProps) => (
                                <Box
                                    className="flex flex-column align-items-left"
                                    style={{ flex: "1" }}
                                >
                                    <Typography>{props?.message.summary}</Typography>
                                    <Box className="font-medium text-lg my-3 text-900">
                                        {props?.message.detail}
                                    </Box>
                                    <Button
                                        className="p-button-sm flex"
                                        style={{ cursor: "pointer", color: "inherit" }}
                                        onClick={() => {
                                            ref.current?.clear();
                                            handleClose();
                                        }}
                                    >
                                        Sim
                                    </Button>
                                    <Button
                                        className="p-button-sm flex"
                                        style={{ cursor: "pointer", color: "inherit" }}
                                        onClick={() => {
                                            ref.current?.clear();
                                            setIsToastVisible(false);
                                        }}
                                    >
                                        Não
                                    </Button>
                                </Box>
                            ),
                        },
                        undefined,
                        true
                    );
                    setIsToastVisible(true);
                }
            } else {
                handleClose();
            }
        },
        [
            inEdit,
            inInsert,
            handleClose,
            statusMessage,
            isToastVisible,
            cep,
            citiesList,
            cnhCategoryList,
            countriesList,
            driverAddress,
            driverAddressComplement,
            driverAddressNumber,
            driverBirthDate,
            driverCity,
            driverCnh,
            driverCnhCategory,
            driverCnhExpireDate,
            driverCountry,
            driverCpf,
            driverEmail,
            driverHasWhatsApp,
            driverIdentifiers,
            driverName,
            driverPhone,
            driverState,
            statesList,
        ]
    );

    const onUpdateStatus = useCallback(
        async (id: number, status: string) => {
            const token: string = cookies.token || sessionStorage.getItem("token");
            const currentParameters: SelectedParametersType = cookies.selectedParameters;

            const customerId = location?.state?.customerId ?? (!getCurrentUser.configs.isManager ? currentParameters.customer.id : customer.id);
            // const departmentId = location?.state?.departmentId ?? (!getCurrentUser.configs.isManager && !currentParameters.isViewingAll ? currentParameters.department.id : department.id);

            setLoading(true);
            try {
                await updateDriverStatusById(
                    token,
                    id,
                    customerId,
                    status
                );
                setTextValidation("Registro atualizado com sucesso.");
                setStatusMessage("success");
                setFieldsIsValid(false);
            } catch (error: any) {
                const { data } = error.response

                setLoading(false);
                setFieldsIsValid(false);
                setStatusMessage("warn");
                setTextValidation(data.reason);
            } finally {
                setTimeout(() => {
                    handleClose();
                    getAllDrivers();
                }, 8000);
            }
        },
        [cookies.token, cookies.selectedParameters, getAllDrivers, handleClose, location?.state?.customerId, customer.id, getCurrentUser.configs.isManager]
    );

    const getReport = useCallback(async (type: string) => {
        const token: string = cookies.token || sessionStorage.getItem("token");
        const currentParameters: SelectedParametersType = cookies.selectedParameters;

        const customerId = location?.state?.customerId ?? (!getCurrentUser.configs.isManager ? currentParameters.customer.id : customer.id);
        const departmentId = location?.state?.departmentId ?? (!getCurrentUser.configs.isManager && !currentParameters.isViewingAll ? currentParameters.department.id : department.id);
        const isViewAll = getCurrentUser.configs.isManager && !location?.state?.departmentId ? isViewingAll : (!getCurrentUser.configs.isManager && currentParameters.isViewingAll);

        let reportType = type;
        let isSimpleType = false;
        if (type.includes("simple")) {
            reportType = reportType.split(" ")[0];
            isSimpleType = true;
        };
        // simpleXlsxExport = false

        setLoading(true);
        let dataBuffer = new ArrayBuffer(0);
        try {
            const { data } = await findAllDriversExportResponse(token,
                customerId,
                departmentId,
                (driversList.length > 0 && driversList[0].activated)
                    ? "activated"
                    : "deactivated",
                reportType,
                isViewAll,
                isSimpleType)

            if ((data as ArrayBuffer).byteLength === 0) {
                setTextValidation("Nenhum dado para mostrar no relatório.");
                setStatusMessage("warn");
                setFieldsIsValid(false);
            } else {
                setTextValidation("Relatório gerado com sucesso.");
                setStatusMessage("success");
                setFieldsIsValid(false);
                dataBuffer = data;
            }
        } catch (error: any) {
            const { data } = error.response

            setLoading(false);
            setFieldsIsValid(false);
            setStatusMessage("warn");
            setTextValidation(data.reason);
        } finally {
            setTimeout(() => {
                handleClose();
                setReport(dataBuffer);
                setExportType(type);
            }, 3000);
        }
    }, [isViewingAll, cookies.token, cookies.selectedParameters, location?.state?.customerId, location?.state?.departmentId, driversList, customer.id, department.id, getCurrentUser.configs.isManager, handleClose]);

    useEffect(() => {
        if (report.byteLength > 1) {
            const typeExport = (exportType === "pdf" ? 'application/pdf' : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
            const file = new Blob([report], { type: typeExport });
            const fileURL = URL.createObjectURL(file);
            window.open(fileURL);
            setReport(new ArrayBuffer(0));
        }
    }, [report, exportType]);

    const handleFormChange = useCallback((index: number, itemValue: string) => {
        const updatedFields = identifierFields.map((field, i) =>
            i === index ? { ...field, value: itemValue } : field
        );

        setIdentifierFields(updatedFields);
        setDriverIndentifiers([...updatedFields.map(a => a.value)]);
    }, [identifierFields]);

    const addNewFields = useCallback(() => {
        setIdentifierFields([...identifierFields, { key: `identifier${identifierFields.length + 1}`, value: "", label: `Identificador ${identifierFields.length + 1}` }]);
    }, [identifierFields]);

    const removeField = useCallback((index: number) => {
        const updatedFields = identifierFields.filter((_, i) => i !== index);
        setIdentifierFields(updatedFields);
        setDriverIndentifiers([...updatedFields.map(a => a.value)]);
    }, [identifierFields]);

    const handleOnEditValues = useCallback((selectedDriver: DriverType) => {
        if (selectedDriver?.name && !inInsert) {
            setDriverName(selectedDriver.name);
            setDriverCpf(selectedDriver?.cpf);
            setDriverAddress(selectedDriver.address);
            setDriverCnh(selectedDriver?.cnh ?? "");
            setDriverCnhExpireDate(selectedDriver.cnhExpireDate ? dayjs(selectedDriver?.cnhExpireDate).toISOString() : dayjs().add(1, "day").toISOString());
            setDriverCnhCategory(cnhCategoryList.find((item) => item.id === selectedDriver.cnhCategoryId)?.name ?? "");
            setDriverBirthDate(dayjs(selectedDriver.birthDate).startOf("day").toDate().toISOString());
            setDriverCountry(countriesList.find((item) => item.id === selectedDriver.countryId)?.name ?? "");
            setCep(selectedDriver.cep);
            setDriverAddressNumber(selectedDriver.addressNumber!!);
            setDriverAddressComplement(selectedDriver.complement);
            setDriverPhone(selectedDriver.phone);
            setDriverHasWhatsApp(selectedDriver?.isWhatsApp);
            setDriverEmail(selectedDriver.email);
            setDriverRegistration(selectedDriver?.driverRegistrationNumber ?? "");
            setUseRegisterNumber(selectedDriver.useRegisterNumber);

            if (selectedDriver.driverIdentifiers.length > 0) {
                const values: any = [];
                selectedDriver.driverIdentifiers.forEach((item, index) => {
                    index === 0 ? values.push({ key: "identifier", value: item.split("-")[0], label: "Identificador" }) : values.push({ key: `identifier${values.length + 1}`, value: item.split("-")[0], label: `Identificador ${values.length + 1}` })
                    setIdentifierFields(values);
                    setDriverIndentifiers([...values.map((a: any) => a.value)]);
                });
            }
        }
    }, [
        inInsert,
        cnhCategoryList,
        countriesList
    ]);

    const [debouncedQuery, setDebouncedQuery] = useState(query);
    const [lastRemoteQuery, setLastRemoteQuery] = useState("");

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedQuery(query);
        }, 1000); // tempo para considerar que PAROU de digitar

        return () => clearTimeout(handler);
    }, [query]);

    const getBySearch = useCallback(() => {
        if (((customer.name && secretary.name && department.name) && !isViewingAll) ||
            (!getCurrentUser.configs.isManager && getCurrentUser.customer.name) ||
            (getCurrentUser.configs.isManager && isViewingAll && customer.name)) {

            const localResult = getFilteredList(
                ["name", "cpf", "driverRegistrationNumber", "cnh", "driverIdentifiers"],
                driversList,
                debouncedQuery
            );

            if (localResult.length > 0) {
                setFilteredList(localResult);
            } else {
                setFilteredList([]);
            }

            // → evita loop: só chama API se query mudou
            if (debouncedQuery !== lastRemoteQuery && localResult.length <= 0) {
                setLastRemoteQuery(debouncedQuery);
                getAllDrivers(debouncedQuery);
            }
        }
    }, [
        debouncedQuery,
        getAllDrivers,
        driversList,
        customer.name,
        secretary.name,
        department.name,
        getCurrentUser.configs.isManager,
        getCurrentUser.customer.name,
        isViewingAll,
        lastRemoteQuery
    ]);

    useEffect(() => {
        getBySearch();
    }, [getBySearch]);

    const verifyBeforeUpdateStatus = useCallback(
        (id: number, status: string) => {
            const ref = toastModalRef;
            if (!isToastVisible) {
                setToastRefToOpen(
                    ref,
                    "Deseja realmente atualizar o status desse registro?",
                    "Atenção!",
                    statusMessage,
                    {
                        content: (props: ContentProps) => (
                            <Box
                                className="flex flex-column align-items-left"
                                style={{ flex: "1" }}
                            >
                                <Typography>{props?.message.summary}</Typography>
                                <Box className="font-medium text-lg my-3 text-900">
                                    {props?.message.detail}
                                </Box>
                                <Button
                                    className="p-button-sm flex"
                                    style={{ cursor: "pointer", color: "inherit" }}
                                    onClick={() => {
                                        ref.current?.clear();
                                        setIsToastVisible(false);
                                        onUpdateStatus(id, status);
                                    }}
                                >
                                    Sim
                                </Button>
                                <Button
                                    className="p-button-sm flex"
                                    style={{ cursor: "pointer", color: "inherit" }}
                                    onClick={() => {
                                        ref.current?.clear();
                                        setIsToastVisible(false);
                                    }}
                                >
                                    Não
                                </Button>
                            </Box>
                        ),
                    },
                    undefined,
                    true
                );
                setIsToastVisible(true);
            }
        },
        [onUpdateStatus, isToastVisible, statusMessage]
    );

    const loadingEsqueleton = useMemo(() => {
        return (
            <Grid
                className="container "
                sx={{
                    height: 650,
                    width: 950,
                }}
            >
                {Array.from(new Array(1)).map((_, i) => (
                    <Box key={i} sx={{ width: "100%", height: 650, padding: 5 }}>
                        <Skeleton height={70} />
                        <Skeleton height={70} />
                        <Skeleton height={70} />
                        <Skeleton height={70} />
                        <Skeleton height={70} />
                        <Skeleton height={70} />
                    </Box>
                ))}
            </Grid>
        );
    }, []);

    const IOSSwitch = useMemo(() => styled((props: SwitchProps) => (
        <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
    ))(({ theme }) => ({
        width: 42,
        height: 26,
        padding: 0,
        '& .MuiSwitch-switchBase': {
            padding: 0,
            margin: 2,
            transitionDuration: '300ms',
            '&.Mui-checked': {
                transform: 'translateX(16px)',
                color: '#fff',
                '& + .MuiSwitch-track': {
                    backgroundColor: '#65C466',
                    opacity: 1,
                    border: 0,
                    ...theme.applyStyles('dark', {
                        backgroundColor: '#2ECA45',
                    }),
                },
                '&.Mui-disabled + .MuiSwitch-track': {
                    opacity: 0.5,
                },
            },
            '&.Mui-focusVisible .MuiSwitch-thumb': {
                color: '#33cf4d',
                border: '6px solid #fff',
            },
            '&.Mui-disabled .MuiSwitch-thumb': {
                color: theme.palette.grey[100],
                ...theme.applyStyles('dark', {
                    color: theme.palette.grey[600],
                }),
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 0.7,
                ...theme.applyStyles('dark', {
                    opacity: 0.3,
                }),
            },
        },
        '& .MuiSwitch-thumb': {
            boxSizing: 'border-box',
            width: 22,
            height: 22,
        },
        '& .MuiSwitch-track': {
            borderRadius: 26 / 2,
            backgroundColor: '#E9E9EA',
            opacity: 1,
            transition: theme.transitions.create(['background-color'], {
                duration: 500,
            }),
            ...theme.applyStyles('dark', {
                backgroundColor: '#39393D',
            }),
        },
    })), []);

    const handleCloseIdentifierHistory = useCallback(() => {
        setIsOpenIdentifierHistory(false);
        setIdentifierHistorySearch("");
    }, []);

    const handleCloseDriverParameter = useCallback(() => {
        setIsOpenDriverParameter(false);
        setDriverParameterHasUnsavedChanges(false);
    }, []);

    const verifyBeforeCloseDriverParameter = useCallback(() => {
        const ref = toastDriverParameterRef;

        if (!driverParameterHasUnsavedChanges) {
            handleCloseDriverParameter();
            return;
        }

        if (!isToastVisible) {
            setToastRefToOpen(
                ref,
                "Existem alterações não salvas. Deseja realmente sair sem salvar?",
                "Atenção!",
                statusMessage,
                {
                    content: (props: ContentProps) => (
                        <Box
                            className="flex flex-column align-items-left"
                            style={{ flex: "1" }}
                        >
                            <Typography>{props?.message.summary}</Typography>
                            <Box className="font-medium text-lg my-3 text-900">
                                {props?.message.detail}
                            </Box>
                            <Button
                                className="p-button-sm flex"
                                style={{ cursor: "pointer", color: "inherit" }}
                                onClick={() => {
                                    ref.current?.clear();
                                    setIsToastVisible(false);
                                    handleCloseDriverParameter();
                                }}
                            >
                                Sim
                            </Button>
                            <Button
                                className="p-button-sm flex"
                                style={{ cursor: "pointer", color: "inherit" }}
                                onClick={() => {
                                    ref.current?.clear();
                                    setIsToastVisible(false);
                                }}
                            >
                                Não
                            </Button>
                        </Box>
                    ),
                },
                undefined,
                true
            );
            setIsToastVisible(true);
        }
    }, [driverParameterHasUnsavedChanges, handleCloseDriverParameter, isToastVisible, statusMessage]);

    const handleOpenDriverParameters = useCallback(() => {
        setDriverParameterSection("parameters");
        setIsOpenDriverParameter(true);
    }, []);

    const handleOpenDriverAttachments = useCallback(() => {
        setDriverParameterSection("attachments");
        setIsOpenDriverParameter(true);
    }, []);

    const identifierHistoryDialog = useMemo(() => {
        return (
            <Dialog
                open={isOpenIdentifierHistory}
                onClose={handleCloseIdentifierHistory}
                fullWidth
                maxWidth="md"
                aria-labelledby="identifier-history-dialog-title"
                PaperProps={{
                    className: "tw-overflow-hidden tw-rounded-2xl tw-bg-white tw-shadow-2xl",
                    sx: {
                        borderRadius: 4,
                        backgroundColor: "#ffff",
                        boxShadow: "0 24px 70px rgba(0, 0, 0, 0.28)",
                    },
                }}
            >
                <Box className="tw-bg-white tw-p-4 sm:tw-p-6" sx={{ p: { xs: 2, sm: 3 }, background: "#ffff" }}>
                    <Box
                        className="tw-mb-4 tw-flex tw-flex-col tw-gap-3 tw-rounded-xl tw-bg-gtr-sidebar tw-p-4 sm:tw-flex-row sm:tw-items-center sm:tw-justify-between"
                        sx={{
                            display: "flex",
                            flexDirection: { xs: "column", sm: "row" },
                            justifyContent: "space-between",
                            alignItems: { sm: "center" },
                            gap: 1.5,
                            mb: 2,
                            p: 2,
                            borderRadius: 3,
                            backgroundImage: "linear-gradient(to right, #006C77, #09414A)",
                        }}
                    >
                        <Typography variant="subtitle1" sx={{ fontWeight: "bold", fontFamily: "Prometo", color: "#ffff" }}>
                            Histórico de Trocas de Identificadores — {selectedDriver?.name}
                        </Typography>
                        <TextField
                            size="small"
                            placeholder="Pesquisar identificador..."
                            value={identifierHistorySearch}
                            onChange={(e) => setIdentifierHistorySearch(e.target.value)}
                            sx={{
                                width: { xs: "100%", sm: "240px" },
                                '& .MuiInputBase-root': {
                                    height: '36px',
                                    fontFamily: "Prometo",
                                    fontSize: '13px',
                                    backgroundColor: "#fff",
                                    borderRadius: 2,
                                },
                            }}
                            InputProps={{
                                startAdornment: <SearchOutlined sx={{ fontSize: 18, mr: 0.5, color: "#666" }} />,
                                endAdornment: identifierHistorySearch && (
                                    <IconButton size="small" onClick={() => setIdentifierHistorySearch("")}>
                                        <CloseOutlined sx={{ fontSize: 16 }} />
                                    </IconButton>
                                )
                            }}
                        />
                    </Box>

                    <TableContainer className="tw-rounded-xl" component={Paper} sx={{
                        maxHeight: 400,
                        boxShadow: "none",
                        border: "1px solid #e0e0e0",
                        borderRadius: 3,
                        overflowY: "auto",
                        scrollbarWidth: "thin",
                        scrollbarColor: "#c1c1c1 transparent",
                        "&::-webkit-scrollbar": { width: "5px" },
                        "&::-webkit-scrollbar-track": { background: "transparent" },
                        "&::-webkit-scrollbar-thumb": { backgroundColor: "#c1c1c1", borderRadius: "10px" },
                        "&::-webkit-scrollbar-thumb:hover": { backgroundColor: "#9e9e9e" },
                    }}>
                        <Table stickyHeader size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={{ fontWeight: "bold", fontFamily: "Prometo", fontSize: "12px", background: "#09414A", color: "#fff" }}>Identificador</TableCell>
                                    <TableCell sx={{ fontWeight: "bold", fontFamily: "Prometo", fontSize: "12px", background: "#09414A", color: "#fff" }}>Código</TableCell>
                                    <TableCell sx={{ fontWeight: "bold", fontFamily: "Prometo", fontSize: "12px", background: "#09414A", color: "#fff" }}>Status vínculo</TableCell>
                                    <TableCell sx={{ fontWeight: "bold", fontFamily: "Prometo", fontSize: "12px", background: "#09414A", color: "#fff" }}>Status identificador</TableCell>
                                    <TableCell sx={{ fontWeight: "bold", fontFamily: "Prometo", fontSize: "12px", background: "#09414A", color: "#fff" }}>Período do vínculo</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {(() => {
                                    const filtered = selectedDriver?.identifierHistory?.filter((item: any) =>
                                        !identifierHistorySearch || item.identifierUniqueId?.toLowerCase().includes(identifierHistorySearch.toLowerCase())
                                    );

                                    if (!filtered || filtered.length === 0) {
                                        return (
                                            <TableRow sx={{ animation: 'fadeIn 0.3s ease-out' }}>
                                                <TableCell colSpan={5} align="center" sx={{ py: 6, color: "#666", fontFamily: "Prometo", fontStyle: "italic" }}>
                                                    Nenhum dado encontrado
                                                </TableCell>
                                            </TableRow>
                                        );
                                    }

                                    return filtered.map((item: any, idx: number) => (
                                        <TableRow
                                            key={item.id || idx}
                                            hover
                                            sx={{
                                                animation: 'fadeIn 0.3s ease-out forwards',
                                                opacity: 0,
                                                '@keyframes fadeIn': {
                                                    '0%': { opacity: 0, transform: 'translateY(8px)' },
                                                    '100%': { opacity: 1, transform: 'translateY(0)' },
                                                },
                                                transition: 'background-color 0.2s ease',
                                            }}
                                        >
                                            <TableCell sx={{ fontFamily: "Prometo", fontSize: "12px" }}>{item.identifierUniqueId ?? "—"}</TableCell>
                                            <TableCell sx={{ fontFamily: "Prometo", fontSize: "12px" }}>{item.identifierCode ?? "—"}</TableCell>
                                            <TableCell>
                                                <Chip
                                                    size="small"
                                                    label={item.activated ? "Ativo" : "Removido"}
                                                    icon={<CheckCircleOutlineOutlined style={{ fontSize: 14, color: item.activated ? "#0FB403" : "#dc3545" }} />}
                                                    sx={{
                                                        fontFamily: "Prometo",
                                                        fontSize: "11px",
                                                        color: item.activated ? "#0FB403" : "#dc3545",
                                                        borderColor: item.activated ? "#0FB403" : "#dc3545",
                                                    }}
                                                    variant="outlined"
                                                />
                                            </TableCell>
                                            <TableCell>
                                                <Chip
                                                    size="small"
                                                    label={item.identifierActivated ? "Ativo" : "Inativo"}
                                                    icon={<CheckCircleOutlineOutlined style={{ fontSize: 14, color: item.identifierActivated ? "#0FB403" : "#dc3545" }} />}
                                                    sx={{
                                                        fontFamily: "Prometo",
                                                        fontSize: "11px",
                                                        color: item.identifierActivated ? "#0FB403" : "#dc3545",
                                                        borderColor: item.identifierActivated ? "#0FB403" : "#dc3545",
                                                    }}
                                                    variant="outlined"
                                                />
                                            </TableCell>
                                            <TableCell sx={{ fontFamily: "Prometo", fontSize: "12px", color: "#b77700" }}>
                                                <div>
                                                    Início: {item.createdAt
                                                        ? dayjs(item.createdAt).format("DD/MM/YYYY HH:mm")
                                                        : "—"}
                                                </div>
                                                <div>
                                                    Fim: {item.updatedAt
                                                        ? dayjs(item.updatedAt).format("DD/MM/YYYY HH:mm")
                                                        : "—"}
                                                </div>
                                            </TableCell>
                                        </TableRow>
                                    ));
                                })()}
                            </TableBody>
                        </Table>
                    </TableContainer>

                    <DialogActions sx={{ px: 0, pb: 0, pt: 2, borderTop: "1px solid rgba(0, 0, 0, 0.08)", mt: 2 }}>
                        <Button
                            onClick={handleCloseIdentifierHistory}
                            variant="contained"
                            sx={{
                                background: "#dc3545",
                                color: "#fff",
                                fontFamily: "Prometo",
                                textTransform: "none",
                                '&:hover': { background: "#c82333" }
                            }}
                        >
                            Fechar
                        </Button>
                    </DialogActions>
                </Box>
            </Dialog>
        );
    }, [
        selectedDriver?.identifierHistory,
        selectedDriver?.name,
        isOpenIdentifierHistory,
        identifierHistorySearch,
        handleCloseIdentifierHistory
    ]);

    const driverParameterCustomerId = useMemo(() => {
        return location?.state?.customerId ??
            (!getCurrentUser.configs.isManager ? currentParameters.customer.id : customer.id);
    }, [
        location?.state?.customerId,
        getCurrentUser.configs.isManager,
        currentParameters.customer.id,
        customer.id,
    ]);

    const driverParameterDialog = useMemo(() => {
        const isDisabled =
            (location?.state?.canEdit === false) ||
            (location?.state?.permissions?.canEdit === false) ||
            isImpersonationLocked();

        const sectionTitle =
            driverParameterSection === "attachments" ? "Anexos do condutor" : "Parâmetros";

        return (
            <Dialog
                open={isOpenDriverParameter}
                onClose={verifyBeforeCloseDriverParameter}
                fullWidth
                maxWidth="md"
                aria-labelledby="driver-parameter-dialog-title"
                PaperProps={{
                    className: "tw-overflow-hidden tw-rounded-2xl tw-bg-white tw-shadow-2xl",
                    sx: {
                        backgroundColor: "#ffff",
                        boxShadow: "0 24px 70px rgba(0, 0, 0, 0.28)",
                        borderRadius: 4,
                        padding: { xs: 1, sm: 2.5 },
                        width: "100%",
                        maxHeight: {
                            xs: "calc(100vh - 24px)",
                            sm: "calc(100vh - 64px)",
                        },
                        overflow: "hidden",
                    },
                }}
            >
                <Toast
                    ref={toastDriverParameterRef}
                    position="center"
                    baseZIndex={1500}
                    onShow={() => {
                        setIsToastVisible(true);

                        if (validationText) {
                            setTimeout(() => {
                                setFieldsIsValid(true);
                                setIsToastVisible(false);
                            }, 3000);
                        }
                    }}
                />

                <Box
                    className="tw-flex tw-min-h-0 tw-flex-col tw-overflow-hidden tw-bg-white"
                    sx={{
                        background: "#ffff",
                        display: "flex",
                        flexDirection: "column",
                        minHeight: 0,
                        overflow: "hidden",
                    }}
                >
                    <Paper
                        className="tw-flex-none tw-rounded-xl tw-bg-gtr-sidebar tw-text-white tw-shadow-sm"
                        elevation={0}
                        sx={{
                            backgroundImage: "linear-gradient(to right, #006C77, #09414A)",
                            borderRadius: "12px",
                            padding: "8px 12px",
                            marginBottom: 2,
                            color: "#fff",
                            flexShrink: 0,
                        }}
                    >
                        <Box
                            sx={{
                                position: "relative",
                                display: "flex",
                                alignItems: "center",
                                minHeight: "42px",
                                width: "100%",
                            }}
                        >
                            {driverParameterSection !== "parameters" && (
                                <IconButton
                                    title="Voltar para parâmetros"
                                    onClick={handleOpenDriverParameters}
                                    sx={{
                                        color: "#fff",
                                        marginRight: 1,
                                    }}
                                >
                                    <ArrowBackOutlined />
                                </IconButton>
                            )}

                            <Typography
                                variant="body1"
                                sx={{
                                    fontWeight: "bolder",
                                    fontFamily: "Prometo",
                                    fontSize: { xs: "15px", sm: "18px" },
                                    lineHeight: 1.25,
                                    paddingRight: "52px",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                }}
                            >
                                {sectionTitle} — {selectedDriver?.name}
                            </Typography>

                            {/* MAIS OPÇÕES */}
                            <Box
                                sx={{
                                    position: "absolute",
                                    right: 0,
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    display: "flex",
                                    alignItems: "center",
                                    flexDirection: "row-reverse",
                                    width: "42px",
                                    height: "42px",
                                    overflow: "hidden",
                                    transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                                    borderRadius: "25px",
                                    backgroundColor: "rgba(255,255,255,0.05)",
                                    zIndex: 10,
                                    "&:hover": {
                                        width: "86px",
                                        backgroundColor: "rgba(255,255,255,0.15)",
                                        paddingRight: "5px",
                                    },
                                    "&:hover .driver-options-container": {
                                        opacity: 1,
                                        transform: "translateX(0)",
                                    },
                                }}
                            >
                                <Tooltip title="Mais opções" arrow>
                                    <IconButton
                                        aria-label="Mais opções"
                                        onClick={(e) => e.stopPropagation()}
                                        sx={{
                                            color: "#fff",
                                            minWidth: "42px",
                                            width: "42px",
                                            height: "42px",
                                        }}
                                    >
                                        <SettingsOutlined />
                                    </IconButton>
                                </Tooltip>

                                <Box
                                    className="driver-options-container"
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 1,
                                        opacity: 0,
                                        transform: "translateX(20px)",
                                        transition: "all 0.3s ease-out",
                                        paddingRight: "5px",
                                        whiteSpace: "nowrap",
                                    }}
                                >
                                    <Tooltip title="Anexos do condutor" arrow>
                                        <IconButton
                                            aria-label="Anexos do condutor"
                                            onClick={(e) => {
                                                e.stopPropagation();

                                                handleOpenDriverAttachments();
                                            }}
                                            sx={{
                                                background: "#6c757d",
                                                width: "32px",
                                                height: "32px",
                                                "&:hover": {
                                                    background: "#5a6268",
                                                },
                                            }}
                                        >
                                            <AttachFileOutlined
                                                sx={{
                                                    color: "#fff",
                                                    fontSize: "1.1rem",
                                                }}
                                            />
                                        </IconButton>
                                    </Tooltip>
                                </Box>
                            </Box>
                        </Box>
                    </Paper>

                    <Box
                        className="tw-flex-1 tw-overflow-y-auto tw-rounded-xl tw-bg-white"
                        sx={{
                            flex: 1,
                            overflowY: "auto",
                            backgroundColor: "#ffff",
                            padding: 0,
                            borderRadius: "12px",
                            scrollbarWidth: "thin",
                            scrollbarColor: "#006C77 transparent",
                        }}
                    >
                        <DriverParameter
                            driverId={selectedDriver?.id ?? -1}
                            customerId={driverParameterCustomerId ?? -1}
                            section={driverParameterSection}
                            isDisabled={isDisabled}
                            setTextValidation={setTextValidation}
                            setStatusMessage={setStatusMessage}
                            setFieldsIsValid={setFieldsIsValid}
                            onUnsavedChangesChange={setDriverParameterHasUnsavedChanges}
                            onClose={verifyBeforeCloseDriverParameter}
                        />
                    </Box>
                </Box>
            </Dialog>
        );
    }, [
        isOpenDriverParameter,
        verifyBeforeCloseDriverParameter,
        handleOpenDriverParameters,
        handleOpenDriverAttachments,
        driverParameterSection,
        selectedDriver?.name,
        selectedDriver?.id,
        driverParameterCustomerId,
        validationText,
        location?.state?.canEdit,
        location?.state?.permissions?.canEdit,
    ]);

    const DetailsModal = useMemo(() => {
        return (
            <Rmodal
                open={isOpenDetails}
                hiddenBackdrop={false}
                toast={
                    <Toast
                        ref={toastModalRef}
                        position="center"
                        onShow={() => {
                            setIsToastVisible(true);

                            if (validationText) {
                                setTimeout(() => {
                                    setFieldsIsValid(true);
                                    setIsToastVisible(false);
                                }, 3000);
                            }
                        }}
                    />
                }
            >
                <Paper
                    className="tw-flex tw-flex-col tw-overflow-hidden tw-rounded-2xl tw-bg-white tw-shadow-2xl tw-transition-all tw-duration-300 tw-ease-gtr-smooth"
                    sx={style}
                >
                    <Box
                        className="row tw-m-0 tw-flex-1 tw-overflow-y-auto tw-bg-white tw-p-4 sm:tw-p-6"
                        sx={{
                            margin: 0,
                            width: "100%",
                            flex: 1,
                            overflowY: "auto",
                            backgroundColor: "#ffff",
                            boxShadow: "none",
                            padding: { xs: 2, sm: 3 },
                            scrollbarWidth: "thin",
                            scrollbarColor: "#006C77 transparent",
                            "& .MuiOutlinedInput-root": {
                                borderRadius: 2,
                                backgroundColor: "#ffff",
                                transition: "box-shadow 200ms ease, background-color 200ms ease",
                            },
                            "& .MuiOutlinedInput-root:hover": {
                                backgroundColor: "rgba(0, 108, 119, 0.02)",
                            },
                            "& .MuiOutlinedInput-root.Mui-focused": {
                                boxShadow: "0 0 0 3px rgba(0, 108, 119, 0.10)",
                            },
                            "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                borderColor: "#006C77",
                            },
                            "& .MuiAccordion-root": {
                                border: "1px solid rgba(0, 63, 74, 0.10)",
                                borderRadius: "12px !important",
                                boxShadow: "none",
                                overflow: "hidden",
                            },
                        }}
                    >
                        {!loading ? (
                            <>
                                {!info2Expanded && (
                                    <>
                                        <Box className="col-sm-12 col-md-7 d-none d-md-flex">
                                            <Typography variant="body1" sx={{ fontWeight: "bolder", marginBottom: "10px" }}>
                                                Identificação
                                            </Typography>
                                        </Box>

                                        <Box
                                            className="col-sm-12 col-md-5"
                                            style={{ display: "flex", justifyContent: "end" }}
                                        >
                                            {selectedDriver?.name && (
                                                <>
                                                    <Chip
                                                        style={{
                                                            color: selectedDriver.activated
                                                                ? "#00B700"
                                                                : "#dc3545",
                                                            marginRight: 5,
                                                            width: "50%",
                                                            fontWeight: "bolder",
                                                        }}
                                                        clickable={false}
                                                        onClick={() => { }}
                                                        label={
                                                            selectedDriver.activated ? "Ativo" : "Inativo"
                                                        }
                                                    />
                                                    {selectedDriver.activated && (
                                                        <Chip
                                                            style={{
                                                                color: "black",
                                                                marginRight: 5,
                                                                width: "50%",
                                                            }}
                                                            disabled={(location?.state?.canEdit == false) || (location?.state?.permissions?.canEdit == false) || isImpersonationLocked()}
                                                            onClick={() => {
                                                                setInEdit(true);
                                                            }}
                                                            label="Editar"
                                                            icon={
                                                                <DriveFileRenameOutlineOutlined
                                                                    style={{
                                                                        height: 24,
                                                                        width: 24,
                                                                        fill: "black",
                                                                    }}
                                                                />
                                                            }
                                                        />
                                                    )}
                                                    <Chip
                                                        style={{
                                                            color: "black",
                                                            marginRight: 5,
                                                            width: "50%",
                                                        }}
                                                        disabled={((location?.state?.canEdit == false) || (location?.state?.permissions?.canEdit == false)) || isImpersonationLocked()}
                                                        onClick={() => {
                                                            if (!isToastVisible) {
                                                                verifyBeforeUpdateStatus(
                                                                    selectedDriver.id,
                                                                    selectedDriver.activated
                                                                        ? "deactivate"
                                                                        : "activate"
                                                                );
                                                            }
                                                        }}
                                                        label={
                                                            selectedDriver.activated ? "Desativar" : "Ativar"
                                                        }
                                                        icon={
                                                            <RemoveCircleOutlineOutlined
                                                                style={{ height: 24, width: 24, fill: "black" }}
                                                            />
                                                        }
                                                    />
                                                </>
                                            )}
                                        </Box>
                                        {isCnhExpiredDate && <Box className={"col-md-12"} style={{ marginTop: 5, marginBottom: 5 }}>
                                            <Alert
                                                style={{
                                                    borderRadius: 5,
                                                    padding: 10
                                                }}
                                                severity="info"
                                            >
                                                {"A carteira de habilitação do motorista está com a data vencida. Por favor, verifique a situação e faça a atualização cadastral."}
                                            </Alert>
                                        </Box>}
                                    </>
                                )}
                                <Accordion
                                    expanded={infoExpanded}
                                    style={{ padding: 0, margin: 0, boxShadow: "none" }}
                                >
                                    <AccordionSummary
                                        style={{ margin: 0, boxShadow: "none", display: "none" }}
                                        aria-controls="panel2-content"
                                        id="panel2-header"
                                    ></AccordionSummary>

                                    <AccordionDetails>
                                        <Box className="row">
                                            {currentParameters?.isViewingAll && inInsert && <>
                                                <Box className="col-md-6" style={{ marginBottom: 10 }}>
                                                    <Autocomplete
                                                        id="chip-label-select-secretary"
                                                        className="input-select-secretary"
                                                        style={{
                                                            width: "100%",
                                                            minHeight: "56px",
                                                            height: "56px",
                                                            backgroundColor: "#ffffff29",
                                                            borderColor: "lightgray",
                                                        }}
                                                        options={secretariesList}
                                                        value={secretary}
                                                        onChange={(_, option) => {
                                                            setSecretary(option ?? secretaryDefault);
                                                            setDepartment(departmentDefault);
                                                        }}
                                                        disabled={(inEdit || (!inEdit && !inInsert)) as boolean}
                                                        getOptionLabel={(option) => `${option.reducedName}`}
                                                        noOptionsText={"Nada encontrado"}
                                                        renderInput={(params) => (
                                                            <>
                                                                <FormControl
                                                                    className="form-group"
                                                                    style={{ display: "flex" }}
                                                                >
                                                                    <InputLabel
                                                                        id="country-label"
                                                                        required
                                                                        style={{ color: "rgba(0, 0, 0, 0.6)", fontFamily: "Prometo" }}
                                                                        shrink
                                                                    >
                                                                        Secretaria
                                                                    </InputLabel>
                                                                    <TextField
                                                                        {...params}
                                                                        variant="outlined"
                                                                        placeholder="Selecione uma secretaria"
                                                                        autoComplete="off"
                                                                        required
                                                                        InputLabelProps={{ shrink: true }}
                                                                        InputProps={{
                                                                            ...params.InputProps,
                                                                            notched: true,
                                                                            label: "Secretaria",
                                                                            classes: {
                                                                                notchedOutline: "custom-notch",
                                                                            },
                                                                        }}
                                                                    />
                                                                </FormControl>
                                                            </>
                                                        )}
                                                    />
                                                </Box>

                                                <Box className="col-md-6" style={{ marginBottom: 10 }}>
                                                    <Autocomplete
                                                        id="chip-label-select-department"
                                                        className="input-select-department"
                                                        style={{
                                                            width: "100%",
                                                            minHeight: "56px",
                                                            height: "56px",
                                                            backgroundColor: "#ffffff29",
                                                            borderColor: "lightgray",
                                                        }}
                                                        options={departmentsList}
                                                        value={department}
                                                        onChange={(_, option) => {
                                                            setDepartment(option ?? departmentDefault);
                                                        }}
                                                        disabled={(inEdit || (!inEdit && !inInsert)) as boolean}
                                                        getOptionLabel={(option) => `${option.reducedName}`}
                                                        noOptionsText={"Nada encontrado"}
                                                        renderInput={(params) => (
                                                            <>
                                                                <FormControl
                                                                    className="form-group"
                                                                    style={{ display: "flex" }}
                                                                >
                                                                    <InputLabel
                                                                        id="country-label"
                                                                        required
                                                                        style={{ color: "rgba(0, 0, 0, 0.6)", fontFamily: "Prometo" }}
                                                                        shrink
                                                                    >
                                                                        Departamento
                                                                    </InputLabel>
                                                                    <TextField
                                                                        {...params}
                                                                        variant="outlined"
                                                                        placeholder="Selecione um departamento"
                                                                        autoComplete="off"
                                                                        required
                                                                        InputLabelProps={{ shrink: true }}
                                                                        InputProps={{
                                                                            ...params.InputProps,
                                                                            notched: true,
                                                                            label: "Departamento",
                                                                            classes: {
                                                                                notchedOutline: "custom-notch",
                                                                            },
                                                                        }}
                                                                    />
                                                                </FormControl>
                                                            </>
                                                        )}
                                                    />
                                                </Box></>}
                                            <Box
                                                className="col-md-12"
                                                style={{ margin: "15px 0px 15px 0px" }}
                                            >
                                                <FormControl
                                                    className="form-group"
                                                    style={{ display: "flex", width: "100%" }}
                                                >
                                                    <InputLabel
                                                        id="demo-multiple-name-label"
                                                        required
                                                        shrink
                                                        disabled={
                                                            (selectedDriver?.name &&
                                                                !inEdit &&
                                                                !inInsert) as boolean
                                                        }
                                                        style={{ fontFamily: "Prometo" }}
                                                    >
                                                        Nome
                                                    </InputLabel>
                                                    <TextField
                                                        name="name"
                                                        required
                                                        InputProps={{
                                                            label: "Nome",
                                                            notched: true,
                                                            style: { fontFamily: "Prometo" },
                                                        }}
                                                        disabled={
                                                            (selectedDriver?.name &&
                                                                !inEdit &&
                                                                !inInsert) as boolean
                                                        }
                                                        value={driverName}
                                                        onChange={(
                                                            event: ChangeEvent<HTMLInputElement>
                                                        ) => {
                                                            setDriverName(event.target.value);
                                                        }}
                                                        type="text"
                                                        autoComplete="off"
                                                        className="form-control form-control-login"
                                                        placeholder="Digite o nome"
                                                    />
                                                    <IconButton
                                                        className="visibility-password"
                                                        disabled
                                                        onMouseDown={(event: SyntheticEvent) => { }}
                                                        edge="end"
                                                        size="large"
                                                    >
                                                        <PersonOutlineOutlined />
                                                    </IconButton>
                                                </FormControl>
                                            </Box>

                                            <Box
                                                className="col-md-12"
                                                style={{ margin: "15px 0px 15px 0px" }}
                                            >
                                                <FormGroup>
                                                    <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
                                                        <IOSSwitch
                                                            title="Usar matrícula para cadastro"
                                                            checked={useRegisterNumber}
                                                            disabled={(selectedDriver?.name &&
                                                                !inEdit &&
                                                                !inInsert) as boolean}
                                                            onChange={(event) => {
                                                                const checked = event.target.checked;

                                                                if (!checked) {
                                                                    setDriverRegistration("");
                                                                }
                                                                setDriverCpf("");
                                                                setUseRegisterNumber(checked);
                                                            }}
                                                            inputProps={{ 'aria-label': 'ant design' }}
                                                        />
                                                        <Typography style={{ color: "gray" }}>Usa matrícula</Typography>
                                                    </Stack>
                                                </FormGroup>
                                            </Box>

                                            <Box
                                                className="col-md-6"
                                                style={{ margin: "15px 0px 15px 0px" }}
                                            >
                                                {!useRegisterNumber && <FormControl
                                                    className="form-group"
                                                    style={{ display: "flex", width: "100%" }}
                                                >
                                                    <InputLabel
                                                        id="demo-multiple-cpf-label"
                                                        shrink
                                                        required={!useRegisterNumber}
                                                        error={isCpfInvalid}
                                                        disabled={
                                                            (selectedDriver?.name &&
                                                                !inEdit &&
                                                                !inInsert) as boolean
                                                        }
                                                    >
                                                        CPF
                                                    </InputLabel>
                                                    <TextField
                                                        name="cpf"
                                                        type="cpf"
                                                        required={!useRegisterNumber}
                                                        error={isCpfInvalid}
                                                        helperText={isCpfInvalid ? "CPF inválido." : undefined}
                                                        autoComplete="off"
                                                        inputProps={{ maxLength: 11 }}
                                                        InputProps={{ label: "CPF", notched: true }}
                                                        placeholder="Digite o CPF do motorista"
                                                        className="form-control driver-cpf"
                                                        value={cpfFormatter(driverCpf ?? "")}
                                                        onChange={(
                                                            event: React.ChangeEvent<HTMLInputElement>
                                                        ) => {
                                                            setDriverCpf(event.target.value);
                                                        }}
                                                        onBlur={() => {
                                                            setCpfBlurredValue(cpfDigits);
                                                            lookupCpfNow();
                                                        }}
                                                        disabled={
                                                            (selectedDriver?.name &&
                                                                !inEdit &&
                                                                !inInsert) as boolean
                                                        }
                                                    />
                                                    <IconButton
                                                        className="visibility-password"
                                                        disabled
                                                        onMouseDown={(e: SyntheticEvent) => { }}
                                                        edge="end"
                                                        size="large"
                                                    >
                                                        <PinOutlined />
                                                    </IconButton>
                                                </FormControl>}

                                                {!useRegisterNumber && (
                                                    <Box style={{ marginTop: "8px" }}>
                                                        <DirectdIndicators
                                                            loading={directdLoading}
                                                            indicators={directdResult?.indicators ?? null}
                                                            consultedAt={directdResult?.consultedAt}
                                                            stale={directdResult?.stale}
                                                            error={directdError}
                                                        />
                                                    </Box>
                                                )}

                                                {useRegisterNumber && <FormControl
                                                    className="form-group"
                                                    style={{ display: "flex", width: "100%" }}
                                                >
                                                    <InputLabel
                                                        id="demo-multiple-cpf-label"
                                                        shrink
                                                        required={useRegisterNumber}
                                                        disabled={
                                                            (selectedDriver?.name &&
                                                                !inEdit &&
                                                                !inInsert) as boolean
                                                        }
                                                    >
                                                        Registro/Matrícula
                                                    </InputLabel>
                                                    <TextField
                                                        name="registrationNumber"
                                                        type="cpf"
                                                        required={useRegisterNumber}
                                                        autoComplete="off"
                                                        inputProps={{ maxLength: 25 }}
                                                        InputProps={{ label: "Registro/Matrícula", notched: true }}
                                                        placeholder="Digite a matrícula do motorista"
                                                        className="form-control driver-registrationNumber"
                                                        value={registerFormatter(driverRegistration ?? "")}
                                                        onChange={(
                                                            event: React.ChangeEvent<HTMLInputElement>
                                                        ) => {
                                                            setDriverRegistration(event.target.value);
                                                        }}
                                                        disabled={
                                                            (selectedDriver?.name &&
                                                                !inEdit &&
                                                                !inInsert) as boolean
                                                        }
                                                    />
                                                    <IconButton
                                                        className="visibility-password"
                                                        disabled
                                                        onMouseDown={(e: SyntheticEvent) => { }}
                                                        edge="end"
                                                        size="large"
                                                    >
                                                        <PinOutlined />
                                                    </IconButton>
                                                </FormControl>}
                                            </Box>

                                            <Box
                                                className="col-md-6"
                                                style={{ margin: "15px 0px 20px 0px" }}
                                            >
                                                <Autocomplete
                                                    id="chip-label-select-country"
                                                    className="input-select-country"
                                                    style={{
                                                        width: "100%",
                                                        minHeight: "56px",
                                                        height: "56px",
                                                        backgroundColor: "#ffffff29",
                                                        borderColor: "lightgray",
                                                    }}
                                                    options={countriesList}
                                                    value={countriesList.find(a => a.name === driverCountry) ?? null}
                                                    onChange={(_, option) => {
                                                        setDriverCountry(option?.name ?? "");
                                                    }}
                                                    getOptionLabel={(option) => `${option.name}`}
                                                    noOptionsText={"Nada encontrado"}
                                                    renderInput={(params) => (
                                                        <>
                                                            <FormControl
                                                                className="form-group"
                                                                style={{ display: "flex" }}
                                                            >
                                                                <InputLabel
                                                                    id="country-label"
                                                                    required
                                                                    style={{ color: "rgba(0, 0, 0, 0.6)", fontFamily: "Prometo" }}
                                                                    shrink
                                                                    disabled={
                                                                        (selectedDriver?.name &&
                                                                            !inEdit &&
                                                                            !inInsert) as boolean
                                                                    }
                                                                >
                                                                    País
                                                                </InputLabel>
                                                                <TextField
                                                                    {...params}
                                                                    variant="outlined"
                                                                    placeholder="Selecione um país"
                                                                    autoComplete="off"
                                                                    required
                                                                    InputLabelProps={{ shrink: true }}
                                                                    InputProps={{
                                                                        ...params.InputProps,
                                                                        notched: true,
                                                                        label: "País",
                                                                        classes: {
                                                                            notchedOutline: "custom-notch",
                                                                        },
                                                                    }}
                                                                />
                                                            </FormControl>
                                                        </>
                                                    )}
                                                    disabled={
                                                        (selectedDriver?.name &&
                                                            !inEdit &&
                                                            !inInsert) as boolean
                                                    }
                                                />
                                            </Box>

                                            <Box
                                                className="col-md-6"
                                                style={{ margin: "15px 0px 20px 0px" }}
                                            >
                                                <Autocomplete
                                                    id="chip-label-select-state"
                                                    className="input-select-state"
                                                    style={{
                                                        width: "100%",
                                                        minHeight: "56px",
                                                        height: "56px",
                                                        backgroundColor: "#ffffff29",
                                                        borderColor: "lightgray",
                                                    }}
                                                    options={statesList}
                                                    value={statesList.find(a => a.name === driverState) ?? null}
                                                    onChange={(_, option) => {
                                                        setDriverState(option?.name ?? "");
                                                    }}
                                                    getOptionLabel={(option) => `${option.name}`}
                                                    noOptionsText={"Nada encontrado"}
                                                    renderInput={(params) => (
                                                        <>
                                                            <FormControl
                                                                className="form-group"
                                                                style={{ display: "flex" }}
                                                            >
                                                                <InputLabel
                                                                    id="state-label"
                                                                    required
                                                                    style={{ color: "rgba(0, 0, 0, 0.6)", fontFamily: "Prometo" }}
                                                                    shrink
                                                                    disabled={
                                                                        (selectedDriver?.name &&
                                                                            !inEdit &&
                                                                            !inInsert) as boolean
                                                                    }
                                                                >
                                                                    Estado
                                                                </InputLabel>
                                                                <TextField
                                                                    {...params}
                                                                    variant="outlined"
                                                                    placeholder="Selecione um estado"
                                                                    autoComplete="off"
                                                                    required
                                                                    InputLabelProps={{ shrink: true }}
                                                                    InputProps={{
                                                                        ...params.InputProps,
                                                                        notched: true,
                                                                        label: "Estado",
                                                                        classes: {
                                                                            notchedOutline: "custom-notch",
                                                                        },
                                                                    }}
                                                                />
                                                            </FormControl>
                                                        </>
                                                    )}
                                                    disabled={
                                                        (selectedDriver?.name &&
                                                            !inEdit &&
                                                            !inInsert) as boolean
                                                    }
                                                />
                                            </Box>

                                            <Box
                                                className="col-md-6"
                                                style={{ margin: "15px 0px 20px 0px" }}
                                            >
                                                <Autocomplete
                                                    id="chip-label-select-city"
                                                    className="input-select-city"
                                                    style={{
                                                        width: "100%",
                                                        minHeight: "56px",
                                                        height: "56px",
                                                        backgroundColor: "#ffffff29",
                                                        borderColor: "lightgray",
                                                    }}
                                                    options={citiesList}
                                                    value={citiesList.find(a => a.name === driverCity) ?? null}
                                                    onChange={(_, option) => {
                                                        setDriverCity(option?.name ?? "");
                                                    }}
                                                    getOptionLabel={(option) => `${option.name}`}
                                                    noOptionsText={"Nada encontrado"}
                                                    renderInput={(params) => (
                                                        <>
                                                            <FormControl
                                                                className="form-group"
                                                                style={{ display: "flex" }}
                                                            >
                                                                <InputLabel
                                                                    id="city-label"
                                                                    required
                                                                    style={{ color: "rgba(0, 0, 0, 0.6)", fontFamily: "Prometo" }}
                                                                    shrink
                                                                    disabled={
                                                                        (selectedDriver?.name &&
                                                                            !inEdit &&
                                                                            !inInsert) as boolean
                                                                    }
                                                                >
                                                                    Município
                                                                </InputLabel>
                                                                <TextField
                                                                    {...params}
                                                                    variant="outlined"
                                                                    placeholder="Selecione um município"
                                                                    autoComplete="off"
                                                                    required
                                                                    InputLabelProps={{ shrink: true }}
                                                                    InputProps={{
                                                                        ...params.InputProps,
                                                                        notched: true,
                                                                        label: "Município",
                                                                        classes: {
                                                                            notchedOutline: "custom-notch",
                                                                        },
                                                                    }}
                                                                />
                                                            </FormControl>
                                                        </>
                                                    )}
                                                    disabled={
                                                        (selectedDriver?.name &&
                                                            !inEdit &&
                                                            !inInsert) as boolean
                                                    }
                                                />
                                            </Box>

                                            <Box
                                                className="col-md-6"
                                                style={{ margin: "15px 0px 15px 0px" }}
                                            >
                                                <FormControl
                                                    className="form-group"
                                                    style={{ display: "flex", width: "100%" }}
                                                >
                                                    <InputLabel
                                                        id="demo-multiple-cep-label"
                                                        shrink
                                                        disabled={
                                                            (selectedDriver?.name &&
                                                                !inEdit &&
                                                                !inInsert) as boolean
                                                        }
                                                    >
                                                        CEP
                                                    </InputLabel>
                                                    <TextField
                                                        name="cep"
                                                        type="text"
                                                        autoComplete="off"
                                                        InputProps={{ label: "CEP", notched: true }}
                                                        inputProps={{ maxLength: 8 }}
                                                        placeholder="Digite o cep (Opcional)"
                                                        className="form-control driver-cep"
                                                        value={formatterZipCode(cep)}
                                                        error={cepAutofill.hasError}
                                                        helperText={cepAutofill.helperText}
                                                        onChange={(
                                                            event: React.ChangeEvent<HTMLInputElement>
                                                        ) => {
                                                            setCep(event.target.value);
                                                        }}
                                                        onBlur={cepAutofill.onBlur}
                                                        disabled={
                                                            (selectedDriver?.name &&
                                                                !inEdit &&
                                                                !inInsert) as boolean
                                                        }
                                                    />
                                                    <IconButton
                                                        className="visibility-password"
                                                        disabled
                                                        onMouseDown={(e: SyntheticEvent) => { }}
                                                        edge="end"
                                                        size="large"
                                                    >
                                                        <LocalAirportOutlined />
                                                    </IconButton>
                                                </FormControl>
                                            </Box>

                                            <Box
                                                className="col-md-6"
                                                style={{ margin: "15px 0px 15px 0px" }}
                                            >
                                                <FormControl
                                                    className="form-group"
                                                    style={{ display: "flex", width: "100%" }}
                                                >
                                                    <InputLabel
                                                        id="demo-multiple-address-label"
                                                        shrink
                                                        disabled={
                                                            (selectedDriver?.name &&
                                                                !inEdit &&
                                                                !inInsert) as boolean
                                                        }
                                                        style={{ fontFamily: "Prometo" }}
                                                    >
                                                        Endereço
                                                    </InputLabel>
                                                    <TextField
                                                        name="address"
                                                        InputProps={{
                                                            label: "Endereço",
                                                            notched: true,
                                                            style: { fontFamily: "Prometo" },
                                                        }}
                                                        disabled={
                                                            (selectedDriver?.name &&
                                                                !inEdit &&
                                                                !inInsert) as boolean
                                                        }
                                                        value={driverAddress}
                                                        onChange={(
                                                            event: ChangeEvent<HTMLInputElement>
                                                        ) => {
                                                            setDriverAddress(event.target.value);
                                                        }}
                                                        type="text"
                                                        autoComplete="off"
                                                        className="form-control form-control-login"
                                                        placeholder="Digite o endereço (Opcional)"
                                                    />
                                                    <IconButton
                                                        className="visibility-password"
                                                        disabled
                                                        onMouseDown={(e: SyntheticEvent) => { }}
                                                        edge="end"
                                                        size="large"
                                                    >
                                                        <PlaceOutlined />
                                                    </IconButton>
                                                </FormControl>
                                            </Box>

                                            <Box
                                                className="col-md-6"
                                                style={{ margin: "15px 0px 15px 0px" }}
                                            >
                                                <FormControl
                                                    className="form-group"
                                                    style={{ display: "flex", width: "100%" }}
                                                >
                                                    <InputLabel
                                                        id="demo-multiple-number-label"
                                                        shrink
                                                        disabled={
                                                            (selectedDriver?.name &&
                                                                !inEdit &&
                                                                !inInsert) as boolean
                                                        }
                                                        style={{ fontFamily: "Prometo" }}
                                                    >
                                                        Número
                                                    </InputLabel>
                                                    <TextField
                                                        name="number"
                                                        InputProps={{
                                                            label: "Número",
                                                            notched: true,
                                                            style: { fontFamily: "Prometo" },
                                                        }}
                                                        inputProps={{ maxLength: 4 }}
                                                        disabled={
                                                            (selectedDriver?.name &&
                                                                !inEdit &&
                                                                !inInsert) as boolean
                                                        }
                                                        value={driverAddressNumber}
                                                        onChange={(
                                                            event: ChangeEvent<HTMLInputElement>
                                                        ) => {
                                                            setDriverAddressNumber(event.target.value);
                                                        }}
                                                        type="text"
                                                        autoComplete="off"
                                                        className="form-control form-control-login"
                                                        placeholder="Digite o número (Opcional)"
                                                    />
                                                    <IconButton
                                                        className="visibility-password"
                                                        disabled
                                                        onMouseDown={(e: SyntheticEvent) => { }}
                                                        edge="end"
                                                        size="large"
                                                    >
                                                        <PinOutlined />
                                                    </IconButton>
                                                </FormControl>
                                            </Box>

                                            <Box
                                                className="col-md-6"
                                                style={{ margin: "15px 0px 15px 0px" }}
                                            >
                                                <FormControl
                                                    className="form-group"
                                                    style={{ display: "flex", width: "100%" }}
                                                >
                                                    <InputLabel
                                                        id="demo-multiple-complement-label"
                                                        shrink
                                                        disabled={
                                                            (selectedDriver?.name &&
                                                                !inEdit &&
                                                                !inInsert) as boolean
                                                        }
                                                        style={{ fontFamily: "Prometo" }}
                                                    >
                                                        Complemento
                                                    </InputLabel>
                                                    <TextField
                                                        name="name"
                                                        InputProps={{
                                                            label: "Complemento",
                                                            notched: true,
                                                            style: { fontFamily: "Prometo" },
                                                        }}
                                                        disabled={
                                                            (selectedDriver?.name &&
                                                                !inEdit &&
                                                                !inInsert) as boolean
                                                        }
                                                        value={driverAddressComplement}
                                                        onChange={(
                                                            event: ChangeEvent<HTMLInputElement>
                                                        ) => {
                                                            setDriverAddressComplement(event.target.value);
                                                        }}
                                                        type="text"
                                                        autoComplete="off"
                                                        className="form-control form-control-login"
                                                        placeholder="Digite o complemento (Opcional)"
                                                    />
                                                    <IconButton
                                                        className="visibility-password"
                                                        disabled
                                                        onMouseDown={(e: SyntheticEvent) => { }}
                                                        edge="end"
                                                        size="large"
                                                    >
                                                        <AbcOutlined />
                                                    </IconButton>
                                                </FormControl>
                                            </Box>
                                            <Box
                                                className="col-md-6"
                                                style={{ margin: "15px 0px 15px 0px" }}
                                            >
                                                <FormControl
                                                    className="form-group"
                                                    style={{
                                                        width: "100%",
                                                        marginRight: 5,
                                                        marginLeft: 5,
                                                    }}
                                                >
                                                    <LocalizationProvider
                                                        dateAdapter={AdapterDayjs}
                                                        adapterLocale={"pt-br"}
                                                    >
                                                        <DatePicker
                                                            sx={{ width: "100%" }}
                                                            label={"Data de nascimento"}
                                                            format="DD/MM/YYYY"
                                                            onChange={(value) => {
                                                                if (value && value.isValid()) {
                                                                    setDriverBirthDate(value.startOf("day").toDate().toISOString());
                                                                } else {
                                                                    setDriverBirthDate("");
                                                                }
                                                            }}
                                                            value={driverBirthDate ? dayjs(driverBirthDate) : null}
                                                            disabled={
                                                                (selectedDriver?.birthDate &&
                                                                    !inEdit &&
                                                                    !inInsert) as boolean
                                                            }
                                                            maxDate={dayjs()
                                                                .subtract(18, "years")
                                                                .endOf("day")}
                                                            disableFuture
                                                            slotProps={{
                                                                textField: {
                                                                    required: true,
                                                                },
                                                            }}
                                                        />
                                                    </LocalizationProvider>
                                                </FormControl>
                                            </Box>
                                        </Box>
                                    </AccordionDetails>
                                </Accordion>

                                <Box
                                    className="crud-additional-info-bar col-sm-12 col-md-7 d-none d-md-flex"
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        cursor: "pointer",
                                        background: "#f3f4f6",
                                    }}
                                    onClick={() => {
                                        setInfo2Expanded(!info2Expanded);
                                        setInfoExpanded(!infoExpanded);
                                    }}
                                >
                                    <Typography variant="body1" sx={{ fontWeight: "bolder" }}>
                                        Informações adicionais
                                    </Typography>
                                    <Tooltip
                                        title={
                                            "Clique para adicionar informações adicionais sobre o motorista, contato e CNH."
                                        }
                                        style={{ color: "black", margin: 5, cursor: "pointer" }}
                                    >
                                        <HelpOutlineOutlined />
                                    </Tooltip>
                                </Box>

                                <Box
                                    className="crud-additional-info-bar col-sm-12 col-md-5"
                                    style={{
                                        display: "flex",
                                        justifyContent: "end",
                                        cursor: "pointer",
                                        background: "#f3f4f6",
                                    }}
                                    onClick={() => {
                                        setInfo2Expanded(!info2Expanded);
                                        setInfoExpanded(!infoExpanded);
                                    }}
                                >
                                    <IconButton onClick={() => { }} edge="end" size="large">
                                        <ArrowDropDownIcon
                                            style={{
                                                transform: info2Expanded ? "rotate(180deg)" : "",
                                            }}
                                        />
                                    </IconButton>
                                </Box>

                                <Accordion
                                    expanded={info2Expanded}
                                    style={{
                                        padding: 0,
                                        margin: 0,
                                        boxShadow: "none",
                                        marginTop: 5,
                                    }}
                                >
                                    <IconButton
                                        aria-label="toggle accordion"
                                        className="d-none"
                                        onClick={() => { }}
                                        edge="end"
                                        size="large"
                                    >
                                        <ArrowDropDownIcon />
                                    </IconButton>
                                    <AccordionDetails>
                                        <Box className="row">
                                            <Box
                                                className="col-md-6"
                                                style={{ margin: "15px 0px 15px 0px" }}
                                            >
                                                <FormControl
                                                    className="form-group"
                                                    style={{ display: "flex", width: "100%" }}
                                                >
                                                    <InputLabel
                                                        id="demo-multiple-cnh-label"
                                                        shrink
                                                        disabled={
                                                            (selectedDriver?.name &&
                                                                !inEdit &&
                                                                !inInsert) as boolean
                                                        }
                                                    >
                                                        CNH
                                                    </InputLabel>
                                                    <TextField
                                                        name="cnh"
                                                        type="text"
                                                        autoComplete="off"
                                                        InputProps={{ label: "CNH", notched: true }}
                                                        inputProps={{ maxLength: 11 }}
                                                        placeholder="Digite o numero da CNH (Opcional)"
                                                        className="form-control driver-cnh"
                                                        value={driverCnh}
                                                        onChange={(
                                                            event: ChangeEvent<HTMLInputElement>
                                                        ) => {
                                                            setDriverCnh(event.target.value);
                                                        }}
                                                        disabled={
                                                            (selectedDriver?.name &&
                                                                !inEdit &&
                                                                !inInsert) as boolean
                                                        }
                                                    />
                                                    <IconButton
                                                        className="visibility-password"
                                                        disabled
                                                        onMouseDown={(e: SyntheticEvent) => { }}
                                                        edge="end"
                                                        size="large"
                                                    >
                                                        <BadgeOutlined />
                                                    </IconButton>
                                                </FormControl>
                                            </Box>

                                            <Box
                                                className="col-md-6"
                                                style={{ margin: "15px 0px 15px 0px" }}
                                            >
                                                <FormControl
                                                    className="form-group"
                                                    style={{
                                                        width: "100%",
                                                        marginRight: 5,
                                                        marginLeft: 5,
                                                    }}
                                                >
                                                    <LocalizationProvider
                                                        dateAdapter={AdapterDayjs}
                                                        adapterLocale={"pt-br"}
                                                    >
                                                        <DatePicker
                                                            sx={{ width: "100%" }}
                                                            label={"Data de validade"}
                                                            format="DD/MM/YYYY"
                                                            onChange={(value) => {
                                                                setDriverCnhExpireDate(
                                                                    value?.isValid() ? value.toISOString() : ""
                                                                );
                                                            }}
                                                            value={dayjs(driverCnhExpireDate)}
                                                            disabled={
                                                                (selectedDriver?.birthDate &&
                                                                    !inEdit &&
                                                                    !inInsert) as boolean
                                                            }
                                                            minDate={dayjs().add(1, "day")}
                                                            disablePast
                                                            slotProps={{
                                                                textField: {
                                                                    required: false,
                                                                },
                                                            }}
                                                        />
                                                    </LocalizationProvider>
                                                </FormControl>
                                            </Box>

                                            <Box
                                                className="col-md-6"
                                                style={{ margin: "15px 0px 20px 0px" }}
                                            >
                                                <Autocomplete
                                                    id="chip-label-select-category"
                                                    className="input-select-category"
                                                    style={{
                                                        width: "100%",
                                                        minHeight: "56px",
                                                        height: "56px",
                                                        backgroundColor: "#ffffff29",
                                                        borderColor: "lightgray",
                                                    }}
                                                    options={cnhCategoryList}
                                                    value={cnhCategoryList.find(a => a.name === driverCnhCategory) ?? null}
                                                    onChange={(_, option) => {
                                                        setDriverCnhCategory(option?.name ?? "");
                                                    }}
                                                    getOptionLabel={(option) => `${option.name}`}
                                                    noOptionsText={"Nada encontrado"}
                                                    renderInput={(params) => (
                                                        <>
                                                            <FormControl
                                                                className="form-group"
                                                                style={{ display: "flex" }}
                                                            >
                                                                <InputLabel
                                                                    id="category-label"
                                                                    style={{ color: "rgba(0, 0, 0, 0.6)", fontFamily: "Prometo" }}
                                                                    shrink
                                                                    disabled={
                                                                        (selectedDriver?.name &&
                                                                            !inEdit &&
                                                                            !inInsert) as boolean
                                                                    }
                                                                >
                                                                    Categoria
                                                                </InputLabel>
                                                                <TextField
                                                                    {...params}
                                                                    variant="outlined"
                                                                    placeholder="Selecione uma categoria (Opcional)"
                                                                    autoComplete="off"
                                                                    InputLabelProps={{ shrink: true }}
                                                                    InputProps={{
                                                                        ...params.InputProps,
                                                                        notched: true,
                                                                        label: "Categoria",
                                                                        classes: {
                                                                            notchedOutline: "custom-notch",
                                                                        },
                                                                    }}
                                                                />
                                                            </FormControl>
                                                        </>
                                                    )}
                                                    disabled={
                                                        (selectedDriver?.name &&
                                                            !inEdit &&
                                                            !inInsert) as boolean
                                                    }
                                                />
                                            </Box>

                                            <Box
                                                className="col-md-6"
                                                style={{ margin: "15px 0px 20px 0px" }}
                                            >
                                                <FormControl
                                                    className="form-group"
                                                    style={{ display: "flex", width: "100%" }}
                                                >
                                                    <InputLabel
                                                        id="demo-multiple-mail-label"
                                                        shrink
                                                        disabled={
                                                            (selectedDriver?.name &&
                                                                !inEdit &&
                                                                !inInsert) as boolean
                                                        }
                                                    >
                                                        E-mail
                                                    </InputLabel>
                                                    <TextField
                                                        name="email"
                                                        type="email"
                                                        autoComplete="off"
                                                        InputProps={{ label: "E-mail", notched: true }}
                                                        placeholder="Digite o e-mail (Opcional)"
                                                        className="form-control form-control-login"
                                                        disabled={
                                                            (selectedDriver?.name &&
                                                                !inEdit &&
                                                                !inInsert) as boolean
                                                        }
                                                        value={driverEmail}
                                                        onChange={(
                                                            event: React.ChangeEvent<HTMLInputElement>
                                                        ) => {
                                                            setDriverEmail(event.target.value);
                                                        }}
                                                    />
                                                    <IconButton
                                                        aria-label="toggle password visibility"
                                                        className="visibility-password"
                                                        disabled
                                                        onMouseDown={(e: SyntheticEvent) => { }}
                                                        edge="end"
                                                        size="large"
                                                    >
                                                        <EmailOutlined />
                                                    </IconButton>
                                                </FormControl>
                                            </Box>

                                            <Box
                                                className="col-md-8"
                                                style={{ margin: "15px 0px 20px 0px" }}
                                            >
                                                <FormControl
                                                    className="form-group"
                                                    style={{ display: "flex", width: "100%" }}
                                                >
                                                    <InputLabel
                                                        id="demo-multiple-name-label"
                                                        shrink
                                                        required
                                                        disabled={
                                                            (selectedDriver?.name &&
                                                                !inEdit &&
                                                                !inInsert) as boolean
                                                        }
                                                    >
                                                        Telefone
                                                    </InputLabel>
                                                    <TextField
                                                        name="phoneNumber"
                                                        type="tel"
                                                        autoComplete="off"
                                                        required
                                                        InputProps={{ label: "Telefone", notched: true }}
                                                        inputProps={{ maxLength: 11 }}
                                                        className="form-control phone"
                                                        placeholder="Digite o telefone"
                                                        inputMode="numeric"
                                                        value={phoneNumberFormatter(driverPhone)}
                                                        onChange={(
                                                            event: React.ChangeEvent<HTMLInputElement>
                                                        ) => {
                                                            setDriverPhone(event.target.value);
                                                        }}
                                                        disabled={
                                                            (selectedDriver?.name &&
                                                                !inEdit &&
                                                                !inInsert) as boolean
                                                        }
                                                    />
                                                    <IconButton
                                                        aria-label="toggle password visibility"
                                                        className="visibility-password"
                                                        disabled
                                                        onMouseDown={(e: SyntheticEvent) => { }}
                                                        edge="end"
                                                        size="large"
                                                    >
                                                        <PhoneOutlined />
                                                    </IconButton>
                                                </FormControl>
                                            </Box>

                                            <Box
                                                className="col-md-4"
                                                style={{ margin: "15px 0px 20px 0px" }}
                                            >
                                                <FormControlLabel
                                                    style={{ marginRight: 5, marginLeft: 5 }}
                                                    control={
                                                        <Checkbox
                                                            disabled={!inEdit && !inInsert}
                                                            required
                                                            checked={driverHasWhatsApp}
                                                            onChange={(event) => {
                                                                setDriverHasWhatsApp(event.target.checked);
                                                            }}
                                                        />
                                                    }
                                                    label="Número whatsApp"
                                                />
                                            </Box>

                                            {selectedDriver?.name && !inInsert && <Box
                                                className="col-md-12"
                                                style={{ margin: "0px 0px 5px 0px", display: "flex", justifyContent: "flex-end" }}
                                            >
                                                <Chip
                                                    style={{ fontFamily: "Prometo", color: "#ffff", marginRight: 5 }}
                                                    color="info"
                                                    disabled={!selectedDriver?.identifierHistory || selectedDriver.identifierHistory.length === 0}
                                                    onClick={() => {
                                                        setIsOpenIdentifierHistory(true);
                                                    }}
                                                    icon={<TapAndPlayOutlined style={{ color: "#ffff" }} />}
                                                    className="btn btn-info"
                                                    label={`Histórico de identificadores`}
                                                />
                                            </Box>}

                                            {identifierFields.map((it, index) => <Box
                                                className="col-md-12"
                                                style={{ margin: "15px 0px 15px 0px" }}
                                                key={index}
                                            >
                                                <FormControl
                                                    className="form-group"
                                                    style={{ display: "flex", width: "100%" }}
                                                >
                                                    <InputLabel
                                                        id={`demo-multiple-${it.key}-label`}
                                                        shrink
                                                        // required
                                                        disabled={
                                                            (selectedDriver?.name &&
                                                                !inEdit &&
                                                                !inInsert) as boolean
                                                        }
                                                    >
                                                        {it.label}
                                                    </InputLabel>
                                                    <TextField
                                                        name={it.key}
                                                        type="text"
                                                        autoComplete="off"
                                                        InputProps={{
                                                            label: it.label,
                                                            notched: true,
                                                        }}
                                                        inputProps={{ maxLength: 16 }}
                                                        // required
                                                        placeholder="Digite o identificador (Número ou código)"
                                                        className="form-control driver-identifier"
                                                        value={it.value}
                                                        onChange={(
                                                            event: React.ChangeEvent<HTMLInputElement>
                                                        ) => {
                                                            handleFormChange(index, event.target.value);
                                                        }}
                                                        disabled={
                                                            (selectedDriver?.name &&
                                                                !inEdit &&
                                                                !inInsert) as boolean
                                                        }
                                                    />
                                                    <IconButton
                                                        className="visibility-password"
                                                        title="Código"
                                                        onMouseDown={(e: SyntheticEvent) => { }}
                                                        edge="end"
                                                        size="large"
                                                    >
                                                        <Typography>{selectedDriver.driverIdentifiers?.find((a) => a.includes(it.value))?.split("-")[1] ?? ""}</Typography>
                                                    </IconButton>
                                                </FormControl>
                                            </Box>)}

                                            <Box className="col-md-6"
                                                style={{ margin: "15px 0px 15px 0px" }}
                                            >
                                                <Fab size="small" aria-label="add" onClick={() => addNewFields()} disabled={identifierFields.length === 3 || (selectedDriver?.name &&
                                                    !inEdit &&
                                                    !inInsert) as boolean} sx={{
                                                        marginRight: "5px", background: "#00B700", color: "#ffff", "& .disabled": {
                                                            background: "gray",
                                                        }, "&:hover": { background: "#00B700", color: "#ffff" }
                                                    }} >
                                                    <AddOutlined />
                                                </Fab>
                                                <Fab size="small" aria-label="remove" onClick={() => removeField(identifierFields.length - 1)} disabled={identifierFields.length === 1 || (selectedDriver?.name &&
                                                    !inEdit &&
                                                    !inInsert) as boolean} sx={{
                                                        marginRight: "5px", background: "rgba(220, 53, 69, 1)", color: "#ffff", "& .disabled": {
                                                            background: "gray",
                                                        }, "&:hover": { background: "rgba(220, 53, 69, 1)", color: "#ffff" }
                                                    }}>
                                                    <DeleteOutlineOutlined />
                                                </Fab>
                                            </Box>


                                        </Box>
                                    </AccordionDetails>
                                </Accordion>
                            </>
                        ) : (
                            loadingEsqueleton
                        )}
                    </Box>
                    <Box
                        className="tw-flex tw-w-full tw-flex-none tw-justify-end tw-border-t tw-border-black/10 tw-bg-white tw-p-4"
                        sx={{
                            display: "flex",
                            width: "100%",
                            alignSelf: "stretch",
                            justifyContent: "flex-end",
                            padding: 2,
                            borderTop: "1px solid rgba(0, 0, 0, 0.10)",
                            backgroundColor: "#ffff",
                        }}
                    >
                        <Paper
                            className="tw-flex tw-w-full tw-flex-col-reverse tw-gap-2 sm:tw-w-auto sm:tw-flex-row"
                            elevation={0}
                            sx={{
                                display: "flex",
                                flexDirection: { xs: "column-reverse", sm: "row" },
                                justifyContent: "flex-end",
                                width: { xs: "100%", sm: "auto" },
                                marginLeft: "auto",
                                alignSelf: "flex-end",
                                gap: 1,
                                background: "transparent",
                            }}
                        >
                            <Button
                                type="button"
                                style={{
                                    fontFamily: "Prometo",
                                    color: "#ffff",
                                    marginRight: 5,
                                }}
                                onClick={() => {
                                    if (!isToastVisible) {
                                        verifyBeforeCancel(selectedDriver);
                                    }
                                }}
                                className="btn btn-primary btn-block login-button-close tw-transition-transform tw-duration-200 hover:tw-translate-y-[-1px]"
                            >
                                <CloseOutlined style={{ marginRight: 5 }} />
                                <Typography
                                    className="forgot-password"
                                    style={{
                                        fontFamily: "Prometo",
                                        fontSize: "16px",
                                        color: "#ffff",
                                    }}
                                >
                                    Fechar
                                </Typography>
                            </Button>
                            <Button
                                type="button"
                                style={{ fontFamily: "Prometo", color: "#ffff" }}
                                disabled={!inEdit && !inInsert}
                                onClick={() => {
                                    inInsert && !inEdit ? onSave() : onUpdate();
                                }}
                                className="btn btn-primary btn-block login-button tw-transition-transform tw-duration-200 hover:tw-translate-y-[-1px]"
                            >
                                <SaveOutlined style={{ marginRight: 5 }} />
                                <Typography
                                    className="forgot-password"
                                    style={{
                                        fontFamily: "Prometo",
                                        fontSize: "16px",
                                        color: "#ffff",
                                    }}
                                >
                                    Salvar
                                </Typography>
                            </Button>
                        </Paper>
                    </Box>
                </Paper>
            </Rmodal>
        );
    }, [
        cepAutofill.hasError,
        cepAutofill.helperText,
        cepAutofill.onBlur,
        directdLoading,
        directdResult,
        directdError,
        lookupCpfNow,
        isCpfInvalid,
        cpfDigits,
        IOSSwitch,
        driverRegistration,
        useRegisterNumber,
        currentParameters?.isViewingAll,
        department,
        departmentsList,
        secretariesList,
        secretary,
        location?.state?.permissions?.canEdit,
        isCnhExpiredDate,
        verifyBeforeUpdateStatus,
        verifyBeforeCancel,
        cnhCategoryList,
        driverName,
        driverCpf,
        driverCnh,
        driverCnhExpireDate,
        driverCnhCategory,
        driverBirthDate,
        driverCountry,
        driverState,
        driverCity,
        cep,
        driverAddress,
        driverAddressNumber,
        driverAddressComplement,
        driverPhone,
        driverHasWhatsApp,
        driverEmail,
        infoExpanded,
        info2Expanded,
        location?.state?.canEdit,
        isToastVisible,
        validationText,
        selectedDriver,
        isOpenDetails,
        loading,
        loadingEsqueleton,
        inInsert,
        inEdit,
        countriesList,
        statesList,
        citiesList,
        onSave,
        onUpdate,
        addNewFields,
        handleFormChange,
        removeField,
        identifierFields
    ]);

    const getCustomersList = useCallback(async () => {
        const token = cookies.token || sessionStorage.getItem("token");
        try {
            const response = await customerFindAllListResponse(token, cookies.selectedParameters.customer.id);
            setCustomersList(response.data);
        } catch (error) {
            console.log(error);
            setCustomersList([]);
        }
    }, [cookies.token, cookies.selectedParameters.customer.id]);

    useEffect(() => {
        if (getCurrentUser.configs.isManager && (location?.state?.customerId === undefined)) {
            getCustomersList();
        }
    }, [getCustomersList, getCurrentUser.configs.isManager, location?.state?.customerId]);

    const getSecretariesManagerList = useCallback(async () => {
        const token = cookies.token || sessionStorage.getItem("token");
        const customerId = customer.id;

        try {
            const response = await findAllSecretariesByCustomerIdListResponse(
                token,
                customerId
            );
            setSecretariesList(response.data);
        } catch (error) {
            console.log(error);
            setSecretariesList([]);
        }
    }, [cookies.token, customer?.id]);

    useEffect(() => {
        if (getCurrentUser.configs.isManager && customer?.name) {
            getSecretariesManagerList();
        }
    }, [getSecretariesManagerList, customer?.name, getCurrentUser.configs.isManager]);

    const getDepartmentsManagerList = useCallback(async () => {
        const token = cookies.token || sessionStorage.getItem("token");
        const customerId = location?.state?.customerId ?? (!getCurrentUser.configs.isManager ? currentParameters.customer.id : customer.id)
        const secretaryId = secretary.id;

        try {
            const response =
                await findAllDepartmentsByCustomerIdAndSecretaryIdListResponse(
                    token,
                    customerId,
                    secretaryId
                );
            setDepartmentsList(response.data);
        } catch (error) {
            console.log(error);
            setDepartmentsList([]);
        }
    }, [cookies.token, customer.id, secretary.id, location?.state?.customerId, getCurrentUser.configs.isManager, currentParameters.customer.id]);

    useEffect(() => {
        if (getCurrentUser.configs.isManager && customer?.name && secretary?.name) {
            getDepartmentsManagerList();
        }
    }, [getDepartmentsManagerList, secretary?.name, customer?.name, getCurrentUser.configs.isManager]);

    const customerParam =
        <>
            {getCurrentUser.configs.isManager && <Box className="col-md-4" style={{ marginBottom: 10, marginTop: 10 }}>
                <Autocomplete
                    id="chip-label-select-customer"
                    className="input-select-customer"
                    style={{
                        width: "100%",
                        minHeight: "56px",
                        height: "56px",
                        backgroundColor: "#11060629",
                        borderColor: "lightgray",
                    }}
                    options={customersList}
                    value={customer}
                    onChange={(_, option) => {
                        setCustomer(option ?? customerDefault);
                        setSecretary(secretaryDefault);
                        setDepartment(departmentDefault);
                    }}
                    // disabled={!getCurrentUser.configs.isManager}
                    getOptionLabel={(option) => `${option.reducedName}`}
                    noOptionsText={"Nada encontrado"}
                    renderInput={(params) => (
                        <>
                            <FormControl
                                className="form-group"
                                style={{ display: "flex" }}
                            >
                                <InputLabel
                                    id="country-label"
                                    required
                                    style={{ color: "rgba(0, 0, 0, 0.6)", fontFamily: "Prometo" }}
                                    shrink
                                >
                                    Cliente
                                </InputLabel>
                                <TextField
                                    {...params}
                                    variant="outlined"
                                    placeholder="Selecione um cliente"
                                    style={{ background: "#ffff", borderRadius: 5 }}
                                    autoComplete="off"
                                    required
                                    InputLabelProps={{ shrink: true }}
                                    InputProps={{
                                        ...params.InputProps,
                                        notched: true,
                                        label: "Cliente",
                                        classes: {
                                            notchedOutline: "custom-notch",
                                        },
                                    }}
                                />
                            </FormControl>
                        </>
                    )}
                />
            </Box>}

            <Box className={!getCurrentUser.configs.isManager ? "col-md-6" : "col-md-4"} style={{ marginBottom: 10, marginTop: 10 }}>
                <Autocomplete
                    id="chip-label-select-secretary"
                    className="input-select-secretary"
                    style={{
                        width: "100%",
                        minHeight: "56px",
                        height: "56px",
                        backgroundColor: "#ffffff29",
                        borderColor: "lightgray",
                    }}
                    options={secretariesList}
                    value={secretary}
                    disabled={isViewingAll}
                    onChange={(_, option) => {
                        setSecretary(option ?? secretaryDefault);
                        setDepartment(departmentDefault);
                    }}
                    // disabled={!getCurrentUser.configs.isManager}
                    getOptionLabel={(option) => `${option.reducedName}`}
                    noOptionsText={"Nada encontrado"}
                    renderInput={(params) => (
                        <>
                            <FormControl
                                className="form-group"
                                style={{ display: "flex" }}
                            >
                                <InputLabel
                                    id="country-label"
                                    required
                                    style={{ color: "rgba(0, 0, 0, 0.6)", fontFamily: "Prometo" }}
                                    shrink
                                >
                                    Secretaria
                                </InputLabel>
                                <TextField
                                    {...params}
                                    variant="outlined"
                                    placeholder="Selecione uma secretaria"
                                    autoComplete="off"
                                    required
                                    InputLabelProps={{ shrink: true }}
                                    InputProps={{
                                        ...params.InputProps,
                                        notched: true,
                                        label: "Secretaria",
                                        classes: {
                                            notchedOutline: "custom-notch",
                                        },
                                    }}
                                />
                            </FormControl>
                        </>
                    )}
                />
            </Box>

            <Box className={!getCurrentUser.configs.isManager ? "col-md-6" : "col-md-4"} style={{ marginBottom: 10, marginTop: 10 }}>
                <Autocomplete
                    id="chip-label-select-department"
                    className="input-select-department"
                    style={{
                        width: "100%",
                        minHeight: "56px",
                        height: "56px",
                        backgroundColor: "#ffffff29",
                        borderColor: "lightgray",
                    }}
                    disabled={isViewingAll}
                    options={departmentsList}
                    value={department}
                    onChange={(_, option) => {
                        setDepartment(option ?? departmentDefault);
                    }}
                    // isabled={!getCurrentUser.configs.isManager}
                    getOptionLabel={(option) => `${option.reducedName}`}
                    noOptionsText={"Nada encontrado"}
                    renderInput={(params) => (
                        <>
                            <FormControl
                                className="form-group"
                                style={{ display: "flex" }}
                            >
                                <InputLabel
                                    id="department-label"
                                    required
                                    style={{ color: "rgba(0, 0, 0, 0.6)", fontFamily: "Prometo" }}
                                    shrink
                                >
                                    Departamento
                                </InputLabel>
                                <TextField
                                    {...params}
                                    variant="outlined"
                                    placeholder="Selecione uma departamento"
                                    autoComplete="off"
                                    required
                                    InputLabelProps={{ shrink: true }}
                                    InputProps={{
                                        ...params.InputProps,
                                        notched: true,
                                        label: "Departamento",
                                        classes: {
                                            notchedOutline: "custom-notch",
                                        },
                                    }}
                                />
                            </FormControl>
                        </>
                    )}
                />
            </Box>
        </>;

    return (
        <>
            {DetailsModal}
            {identifierHistoryDialog}
            {driverParameterDialog}
            <Toast
                ref={toastRef}
                position="center"
                onShow={() => {
                    setIsToastVisible(true);

                    if (validationText) {
                        setTimeout(() => {
                            setFieldsIsValid(true);
                            setIsToastVisible(false);
                        }, 3000);
                    }
                }}
            />
            <GridTemplate
                columns={columns}
                headerName={"Motoristas"}
                isHiddenMenu={isHiddenMenu}
                isLoading={loading}
                order={"asc"}
                rows={rowsOptions(
                    filteredList,
                    setIsOpenDriverParameter,
                    (driver: DriverType) => {
                        setSelectedDriver(driver);
                        setDriverParameterSection("parameters");
                    },
                    getCurrentUser.permissions,
                )}
                sortField="name"
                withFilter={true}
                withOptions={true}
                query={query}
                setQuery={(value: string) => setQuery(value)}
                filterPlaceholder={"Nome, CPF/Matrícula, CNH ou Ibutton"}
                onRefresh={getAllDrivers}
                onExport={getReport}
                disableAddButton={(location?.state?.canCreate == false) || location?.state?.permissions?.canCreate == false}
                handleNext={(activated: string, page: number, size: number) => getAllDrivers("", activated, page, size)}
                handlePrevious={() => { }}
                isLastPage={isLastPage}
                totalPerPage={numberOfElementsPerPage}
                currentPage={pageNumber}
                totalElements={numberOfElements}
                onAdd={() => {
                    setIsOpenDetails(true);
                    setInInsert(true);
                    setLoading(true);
                    setTimeout(() => {
                        setLoading(false);
                    }, 2000);
                }}
                onClickRow={(item: any) => {
                    setIsOpenDetails(true);
                    setSelectedDriver({ ...item, isWhatsApp: (item?.isWhatsApp ? item?.isWhatsApp : (item?.whatsApp ? item?.whatsApp : false)) });
                    handleOnEditValues({ ...item, isWhatsApp: (item?.isWhatsApp ? item?.isWhatsApp : (item?.whatsApp ? item?.whatsApp : false)) });
                    setLoading(true);
                    setTimeout(() => {
                        setLoading(false);
                    }, 2000);
                }}
                withCustomerParameter={((location?.state?.customerId || !getCurrentUser.configs.isManager) ? false : true)}
                customerParameter={customerParam}
                whithCustomerFilterOption={!location?.state?.departmentId && getCurrentUser.configs.isManager}
                onSetCustomerFilter={setIsViewingAll}
            />
        </>
    );
};

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    display: "flex",
    flexDirection: "column",
    width: { xs: "calc(100vw - 24px)", sm: "min(94vw, 1100px)" },
    maxWidth: 1100,
    maxHeight: "calc(100dvh - 24px)",
    overflow: "hidden",
    bgcolor: "#ffff",
    border: "none",
    boxShadow: "none",
    borderRadius: 4,
    color: "black",
    justifyContent: "center",
    alignItems: "center",
    lineBreak: "anywhere",
    padding: 0,
    fontFamily: "Prometo",
};

export default DriverPage;
